/* GBattle 3D — spray physics R2: full spray and gravity flow; working UI/train loader preserved. */
function gbattle3DInit(root) {
'use strict';
if (!root || root.dataset.gb3Initialized === '1') return;
root.dataset.gb3Initialized = '1';
// Disable browser right-click menus inside the entire game (desktop and mobile).
// Right-button drag still works for looking around. Never affect the Shopify page outside the game.
root.addEventListener('contextmenu',e=>e.preventDefault(),true);
root.addEventListener('dragstart',e=>{if(e.target.closest?.('img,button,canvas'))e.preventDefault()},true);
root.addEventListener('pointerdown', () => { if (document.activeElement !== root) root.focus({preventScroll:true}); }, {capture:true});
const $ = id => root.querySelector('[data-gb3="'+id+'"]');
// A touchscreen Windows laptop may report maxTouchPoints > 0 despite being
// operated with a mouse. Only switch to mobile HUD for a coarse primary pointer.
// A narrow handset with touch and no fine primary pointer is a fallback.
// Inject scoped UI overrides only; user's existing gbattle-3d.css stays untouched.
const gb3R4Styles=document.createElement('style');gb3R4Styles.dataset.gb3SprayMenuR4='';
gb3R4Styles.textContent='/* GBattle Spray Menu R4: scoped addition, never resize the paintbrush toolbar. */\n.gb3-game.gb3-unified .top-actions{gap:4px!important}\n.gb3-game.gb3-unified .top-actions button{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:35px!important;min-width:35px!important;height:35px!important;min-height:35px!important;padding:0!important;margin:0!important;border-radius:8px!important;background:#16232c!important;border:1px solid #4a5964!important;color:#f4f7fa!important;font-size:18px!important;font-weight:800!important;letter-spacing:0!important;line-height:1!important;white-space:nowrap!important;flex:0 0 35px!important;box-sizing:border-box!important}\n.gb3-game.gb3-unified .top-actions button[aria-pressed="true"],\n.gb3-game.gb3-unified .top-actions button[aria-expanded="true"]{background:#e7d24a!important;color:#101820!important;border-color:#e7d24a!important}\n.gb3-game.gb3-unified .top-actions [data-gb3="help"]::after{display:none!important;content:none!important}\n.gb3-game.gb3-unified .top-actions button:focus-visible{outline:2px solid #fff!important;outline-offset:2px!important}\n.gb3-game.gb3-unified.gb3-mobile .top-actions button{width:36px!important;height:36px!important;min-width:36px!important;min-height:36px!important;flex-basis:36px!important}\n/* Existing HUD content is reused rather than cloning controls or handlers. */\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > *{display:none!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-cap-title{display:flex!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-caps{display:grid!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-size,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-opacity,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-dust,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-drips{display:flex!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-size,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-opacity,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-dust,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-drips{display:none!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left{max-height:min(68vh,515px)!important;overflow:auto!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .setting{margin:7px 0!important;gap:4px!important;font-size:11px!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .setting input[type="range"]{accent-color:#e7d24a;max-width:100%}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .gb3-caps{margin-bottom:8px!important}\n@media(max-width:700px){.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .gb3-caps{grid-template-columns:repeat(4,minmax(0,1fr))!important}}\n@media(max-height:550px){.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left{max-height:calc(100% - 92px)!important}}\n';root.appendChild(gb3R4Styles);
// R5 presentation rules apply to this game instance only; do not edit CSS assets.
const gb3R5Styles=document.createElement('style');gb3R5Styles.dataset.gb3MenuR5='';
gb3R5Styles.textContent="/* GBattle R5: PC-only popover separation; mobile spray/color menus unchanged. */\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > *,\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-markers .hud-left > *{display:none!important}\n/* Only color choices, material finishes and the color picker belong to COLORS. */\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-heading-type,\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-heading-color{display:block!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .painttypes,\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .palette{display:grid!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-color-picker{display:block!important}\n/* Only the four markers, all with the owner's same marker icon, belong to MARKERS. */\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-markers .hud-left > .gb3-markers-title{display:flex!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-markers .hud-left > .gb3-marker-options{display:grid!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-subpanel-markers .gb3-markers-title{align-items:center;justify-content:space-between;gap:8px}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-subpanel-markers .gb3-markers-title output{font-size:10px;color:var(--accent);font-weight:800}\n/* Non-invasive top tag suppression: Liquid markup need not be replaced. */\n.gb3-game.gb3-unified .top-actions > .tag{display:none!important}\n/* Mobile: preserve north/south arrows and show west/east arrows in movement stick. */\n.gb3-game.gb3-mobile .touchpad .gb3-stick-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:1;pointer-events:none;user-select:none;color:rgba(247,254,255,.72);font-size:12px;line-height:1;text-shadow:0 1px 3px #000}\n.gb3-game.gb3-mobile .touchpad .gb3-stick-arrow--left{left:7px}\n.gb3-game.gb3-mobile .touchpad .gb3-stick-arrow--right{right:7px}\n";root.appendChild(gb3R5Styles);
const gb3StoryTag=root.querySelector('.top-actions > .tag');
if(gb3StoryTag && gb3StoryTag.textContent.trim()==='WRITE YOUR OWN STORY')gb3StoryTag.remove();
const view=$('view');
// Public train choice is independent of server filenames and source/export format.
// C30 remains the default when the query string does not specify a train.
const gb3RequestedTrain=(new URLSearchParams(location.search).get('gb3train')||'stockholm-c30').toLowerCase();
const gb3ModelChoice=gb3RequestedTrain==='santiago-ns93'?'santiago-ns74':gb3RequestedTrain;
// Stable public IDs: model filenames never carry temporary fix/version labels.
const gb3TrainRegistry=Object.freeze({
 'stockholm-c30':{key:'c30',name:'Stockholm-C30',save:'c30-exterior-v21',paint:'sl-c30-paint.glb',models:{desktop:'sl-c30.glb',mobile:'sl-c30.glb'},country:'Sweden'},
 'stockholm-c6':{key:'c6',name:'Stockholm-C6',save:'stockholm-c6-exterior-v01',paint:'sl-c6-paint.glb',model:'sl-c6.glb',country:'Sweden'},
 'santiago-ns74':{key:'santiago-ns74',name:'Santiago NS-74',save:'santiago-ns93-exterior-v01',combined:true,model:'santiago-ns74.glb',country:'Chile'},
 'paris-mp73':{key:'paris-mp73',name:'Paris MP-73',save:'paris-mp73-exterior-v01',combined:true,model:'paris-mp73.glb',country:'France'},
 'london-2009stock':{key:'london-2009stock',name:'London-2009 Stock',save:'london-2009stock-exterior-v01',paint:'london-2009stock-paint.glb',model:'london-2009stock.glb',country:'United Kingdom'}
});
const gb3KeyToPublic=Object.freeze(Object.fromEntries(Object.entries(gb3TrainRegistry).map(([id,entry])=>[entry.key,id])));
// Only missing URL defaults to C30. Known new train IDs never silently fall back.
const gb3StartChoice=gb3TrainRegistry[gb3ModelChoice]||gb3TrainRegistry['stockholm-c30'];
let gb3TrainSelection=gb3StartChoice.key;
let gb3TrainName=gb3StartChoice.name;
let gb3PaintSaveKey=gb3StartChoice.save;
root.dataset.gb3Train=gb3TrainSelection;

const mobilePlatform=/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
const coarseInput=window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
const isTouchDevice=coarseInput && (mobilePlatform ||
  (window.matchMedia('(max-width: 800px)').matches && !window.matchMedia('(pointer: fine)').matches));
let gb3MobileLongPress=null; // Supplied by toolbar after it is built.
if(isTouchDevice){
 root.classList.add('gb3-mobile');
 // Protect game controls from Android long-press selection, including events
 // dispatched on nested icon labels. Do not affect Shopify content outside root.
 const targetInsideGame=e=>{
   const n=e.target;
   const el=n && n.nodeType===1?n:n?.parentElement;
   return !!(el && root.contains(el) && !el.closest('input[type="text"],textarea,[contenteditable="true"]'));
 };
 const stopSelection=e=>{if(targetInsideGame(e))e.preventDefault();};
 document.addEventListener('selectstart',stopSelection,true);
 document.addEventListener('contextmenu',stopSelection,true);
 document.addEventListener('dragstart',stopSelection,true);
 document.addEventListener('selectionchange',()=>{
   const s=window.getSelection?.();
   if(s && s.rangeCount && s.anchorNode && root.contains(s.anchorNode) &&
     !s.anchorNode.parentElement?.closest('input[type="text"],textarea,[contenteditable="true"]')){
     s.removeAllRanges();
   }
 },true);

 root.addEventListener('contextmenu',e=>{e.preventDefault()},{capture:true});
 root.addEventListener('selectstart',e=>{if(!e.target.closest('input[type=text],textarea'))e.preventDefault()},{capture:true});
 root.addEventListener('dragstart',e=>e.preventDefault(),{capture:true});
 // Some Android browsers still select nested icon text after a prolonged press.
 // Suppress native touch selection for BUTTONS only, then deliver a single click.
 let touchButton=null,touchButtonId=null,touchOriginX=0,touchOriginY=0;
 let holdTimer=null,holdActivated=false;
 function resetHoldTimer(){if(holdTimer!==null){clearTimeout(holdTimer);holdTimer=null;}}
 root.addEventListener('touchstart',e=>{
   const button=e.target.closest?.('button');
   if(!button || e.touches.length!==1)return;
   resetHoldTimer();touchButton=button;touchButtonId=e.changedTouches[0].identifier;
   touchOriginX=e.changedTouches[0].clientX;touchOriginY=e.changedTouches[0].clientY;
   holdActivated=false;
   // The browser cannot select text when pressing the toolbar, even for > 500ms.
   e.preventDefault();
   if(button.closest('.gb3-compact-toolbar')){
     holdTimer=setTimeout(()=>{
       holdTimer=null;
       if(touchButton===button&&root.contains(button)&&typeof gb3MobileLongPress==='function'){
         holdActivated=!!gb3MobileLongPress(button);
       }
     },520);
   }
 },{capture:true,passive:false});
 root.addEventListener('touchmove',e=>{
   if(!touchButton)return;
   const t=Array.from(e.touches).find(x=>x.identifier===touchButtonId);
   if(!t||Math.hypot(t.clientX-touchOriginX,t.clientY-touchOriginY)>12)resetHoldTimer();
 },{capture:true,passive:true});
 root.addEventListener('touchend',e=>{
   if(!touchButton)return;
   const t=Array.from(e.changedTouches).find(x=>x.identifier===touchButtonId);
   if(!t)return;
   e.preventDefault();resetHoldTimer();
   const button=touchButton,wasHold=holdActivated;touchButton=null;touchButtonId=null;holdActivated=false;
   if(!wasHold&&root.contains(button)&&!button.disabled)button.click();
 },{capture:true,passive:false});
 root.addEventListener('touchcancel',()=>{resetHoldTimer();touchButton=null;touchButtonId=null;holdActivated=false;},{capture:true});
}
else root.classList.remove('gb3-mobile','gb3-panel-tools','gb3-panel-session','gb3-immersive');
const gl=view.getContext('webgl',{alpha:false,antialias:true,preserveDrawingBuffer:true});
if(!gl){$('hint').textContent='WebGL unavailable. Try Chrome, Edge or Firefox with GPU acceleration.';return;}
const TAU=Math.PI*2, clamp=(v,a,b)=>Math.max(a,Math.min(b,v)), rnd=(a,b)=>a+Math.random()*(b-a), vec=(x,y,z)=>[x,y,z];
function unit(a){let m=Math.hypot(...a)||1;return a.map(v=>v/m)};
function cross(a,b){return [a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]]}
function dot(a,b){return a[0]*b[0]+a[1]*b[1]+a[2]*b[2]}
function perspective(fov,aspect,near,far){const f=1/Math.tan(fov/2),o=new Float32Array(16);o[0]=f/aspect;o[5]=f;o[10]=(far+near)/(near-far);o[11]=-1;o[14]=2*far*near/(near-far);return o}
function lookAt(e,tar){const f=unit([tar[0]-e[0],tar[1]-e[1],tar[2]-e[2]]),r=unit(cross(f,[0,1,0])),u=cross(r,f);return new Float32Array([r[0],u[0],-f[0],0,r[1],u[1],-f[1],0,r[2],u[2],-f[2],0,-dot(r,e),-dot(u,e),dot(f,e),1]);}
function model(pos,sca,rot=0){const c=Math.cos(rot),s=Math.sin(rot);return new Float32Array([c*sca[0],0,-s*sca[0],0,0,sca[1],0,0,s*sca[2],0,c*sca[2],0,pos[0],pos[1],pos[2],1])}
const vs=`attribute vec3 aP;attribute vec3 aN;attribute vec2 aUV;attribute vec3 aTint;varying vec3 vTint;uniform mat4 uProj,uView,uModel;varying vec3 vNormal,vWorld;varying vec2 vUV;void main(){vec4 w=uModel*vec4(aP,1.0);vWorld=w.xyz;vNormal=mat3(uModel)*aN;vUV=aUV;vTint=aTint;gl_Position=uProj*uView*w;}`;
const fs=`precision mediump float;varying vec3 vNormal,vWorld;varying vec3 vTint;varying vec2 vUV;uniform vec3 uColor,uCamera;uniform sampler2D uTex;uniform float uTexture,uMetal,uFog,uOpacity,uTrain,uBackdrop,uNight;uniform vec3 uTorchOrigin,uTorchTarget;void main(){vec4 tex=uTexture>0.5?texture2D(uTex,vUV):vec4(1.0);if(tex.a<0.015)discard;vec3 n=normalize(vNormal);vec3 sun=normalize(vec3(-0.6,0.9,0.55));float light=mix(0.52+max(dot(n,sun),0.0)*0.52, 0.84+max(dot(n,sun),0.0)*0.17, uTrain);vec3 eye=normalize(uCamera-vWorld);vec3 h=normalize(sun+eye);float spec=pow(max(dot(n,h),0.0),uMetal>0.5?30.0:48.0)*(uMetal>0.5?0.48:0.13);vec3 col=uBackdrop>0.5?tex.rgb*uColor*vTint:tex.rgb*uColor*vTint*light+vec3(spec);if(uBackdrop<0.5&&uFog>0.5){float fog=clamp((distance(uCamera,vWorld)-35.0)/105.0,0.0,1.0);col=mix(col,vec3(.065,.085,.112),fog);}
if(uNight>0.5){vec3 axis=normalize(uTorchTarget-uTorchOrigin);vec3 toPix=vWorld-uTorchOrigin;float ray=length(toPix);float beam=smoothstep(.79,.95,dot(normalize(toPix),axis))*clamp(1.0-ray/27.0,0.0,1.0)*2.4;col*=.048+beam;}
gl_FragColor=vec4(col,tex.a*uOpacity);}`;
function shader(type,src){let s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error(gl.getShaderInfoLog(s));return s}
const program=gl.createProgram();gl.attachShader(program,shader(gl.VERTEX_SHADER,vs));gl.attachShader(program,shader(gl.FRAGMENT_SHADER,fs));gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error(gl.getProgramInfoLog(program));gl.useProgram(program);
const loc={tint:gl.getAttribLocation(program,'aTint'),p:gl.getAttribLocation(program,'aP'),n:gl.getAttribLocation(program,'aN'),uv:gl.getAttribLocation(program,'aUV'),projection:gl.getUniformLocation(program,'uProj'),view:gl.getUniformLocation(program,'uView'),model:gl.getUniformLocation(program,'uModel'),color:gl.getUniformLocation(program,'uColor'),camera:gl.getUniformLocation(program,'uCamera'),texture:gl.getUniformLocation(program,'uTex'),hasTex:gl.getUniformLocation(program,'uTexture'),metal:gl.getUniformLocation(program,'uMetal'),fog:gl.getUniformLocation(program,'uFog'),opacity:gl.getUniformLocation(program,'uOpacity'),train:gl.getUniformLocation(program,'uTrain'),backdrop:gl.getUniformLocation(program,'uBackdrop'),night:gl.getUniformLocation(program,'uNight'),torchOrigin:gl.getUniformLocation(program,'uTorchOrigin'),torchTarget:gl.getUniformLocation(program,'uTorchTarget')};
function faces(){const out=[];const face=(normal,p)=>{const uv=[[0,0],[1,0],[1,1],[0,0],[1,1],[0,1]];for(let i=0;i<6;i++)out.push(...p[i],...normal,...uv[i])};
 const a=-.5,b=.5;
 face([0,0,1],[[a,a,b],[b,a,b],[b,b,b],[a,a,b],[b,b,b],[a,b,b]]);
 face([0,0,-1],[[b,a,a],[a,a,a],[a,b,a],[b,a,a],[a,b,a],[b,b,a]]);
 face([1,0,0],[[b,a,b],[b,a,a],[b,b,a],[b,a,b],[b,b,a],[b,b,b]]);
 face([-1,0,0],[[a,a,a],[a,a,b],[a,b,b],[a,a,a],[a,b,b],[a,b,a]]);
 face([0,1,0],[[a,b,b],[b,b,b],[b,b,a],[a,b,b],[b,b,a],[a,b,a]]);
 face([0,-1,0],[[a,a,a],[b,a,a],[b,a,b],[a,a,a],[b,a,b],[a,a,b]]);return out;}
const quad=[-.5,-.5,0,0,0,1,0,0,.5,-.5,0,0,0,1,1,0,.5,.5,0,0,0,1,1,1,-.5,-.5,0,0,0,1,0,0,.5,.5,0,0,0,1,1,1,-.5,.5,0,0,0,1,0,1];
function mesh(arr,colors=null){let buf=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buf);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(arr),gl.STATIC_DRAW);let tintBuf=null;if(colors){tintBuf=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,tintBuf);gl.bufferData(gl.ARRAY_BUFFER,colors,gl.STATIC_DRAW);}return {buf,tintBuf,count:arr.length/8}}
function gb3DeleteMesh(shape){gl.deleteBuffer(shape.buf);if(shape.tintBuf)gl.deleteBuffer(shape.tintBuf);}
const cube=mesh(faces()),plane=mesh(quad);
function hex(s){let h=s.replace('#','');return [0,2,4].map(x=>parseInt(h.slice(x,x+2),16)/255)}
let scene=[],panels=[],dirty=new Set(),undo=[],strokes=0;
let addingPlaceholder=false;
function add(shape,x,y,z,w,h,d,color,metal=0,rot=0){const o={shape:shape||cube,pos:[x,y,z],size:[w,h,d],color:hex(color),metal,rot,placeholder:addingPlaceholder};scene.push(o);return o}
function box(x,y,z,w,h,d,c,metal=0){return add(cube,x,y,z,w,h,d,c,metal)}
function panel(name,cx,side,len,opt={}){const size=[len,opt.height??2.66,1], z=side*(opt.z??1.665);const o={shape:plane,pos:[cx,opt.y??2.18,z],size,color:[1,1,1],metal:0,rot:0,panel:true,side,len,cx,name,placeholder:addingPlaceholder};o.canvas=document.createElement('canvas');o.canvas.width=opt.width??1536;o.canvas.height=opt.pixelHeight??400;o.ctx=o.canvas.getContext('2d',{willReadFrequently:true});o.tex=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,o.tex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,o.canvas);panels.push(o);return o}
function makeYard(){
 box(0,-.36,0,230,.62,160,'#303b40');
 // Rails extend into BOTH tunnel openings, all the way to the map boundary.
 // A short continuation disappears inside the tunnel beyond the panoramic walls.
 const trackLength=260;
 for(const z of [-1.02,1.02]){
   box(0,.15,z,trackLength,.19,.17,'#adb5b3',1);
   box(0,.21,z+.21,trackLength,.04,.035,'#838d8d',1);
 }
 // Group sleepers into ONE mesh to avoid hundreds of draw calls on Android.
 const sleeperVerts=[];
 const template=faces();
 for(let x=-129.75;x<=129.75;x+=.75){
   for(let i=0;i<template.length;i+=8){
     sleeperVerts.push(x+template[i]*.28,-.05+template[i+1]*.18,template[i+2]*3.4,
       template[i+3],template[i+4],template[i+5],template[i+6],template[i+7]);
   }
 }
 scene.push({shape:mesh(sleeperVerts),pos:[0,0,0],size:[1,1,1],rot:0,color:hex('#473d34'),metal:0});
 // Scenic Stockholm panorama replaces the temporary industrial boxes and lamps.
 // Only the imported C30 is used; no test gray train is constructed.
 // No leftover depot sign geometry; the photographic perimeter is the entire backdrop.
}
makeYard();
// v2.3.6 — cover props: crates and a small maintenance shed on the spectator side.
// Each provides actual line-of-sight cover; the camera cannot pass through them.
const gb3Cover=[];
function gb3Crate(x,z,w=3.3){
 const obj=box(x,1.23,z,w,2.46,2.6,'#786246');
 const trim=box(x,2.53,z,w+.06,.14,2.72,'#4b3928');
 gb3Cover.push({x,z,hx:w/2+.14,hz:1.43,kind:'crate'});
 return [obj,trim];
}
gb3Crate(-41,13.6);gb3Crate(-15,13.4,3.8);gb3Crate(19,13.6,4.2);gb3Crate(42,14.2,3.3);
// Small shed on the yard side. Its walls are solid for shelter and guard sight.
box(61,2.6,17,9,5.2,7.5,'#3b4241');
box(61,5.43,17,10,.5,8.1,'#454946');
box(56.44,2.75,17,.18,5.5,7.9,'#2e3434');
box(61,2.85,13.18,9.05,4.9,.14,'#5d6662');
gb3Cover.push({x:61,z:17,hx:4.72,hz:3.85,kind:'shed'});
// Guard is drawn from inexpensive boxes, and hidden outside a patrol.
const gb3GuardMeshes=[];
function gb3GuardPart(dx,y,dz,w,h,d,color){
 const obj=box(-70, y,7.2,w,h,d,color);
 obj.guard=true;obj.guardOffset=[dx,y,dz];gb3GuardMeshes.push(obj);return obj;
}
gb3GuardPart(0,1.47,0,.7,.91,.42,'#152336'); // jacket
gb3GuardPart(0,2.19,0,.43,.43,.39,'#d8ae8c'); // head
gb3GuardPart(0,2.43,0,.60,.14,.57,'#101b25'); // hat
gb3GuardPart(-.44,1.38,0,.22,.83,.32,'#142337');
gb3GuardPart(.44,1.38,0,.22,.83,.32,'#142337');
gb3GuardPart(-.18,.57,0,.25,1.04,.32,'#20232b');
gb3GuardPart(.18,.57,0,.25,1.04,.32,'#20232b');
gb3GuardPart(0,1.54,.232,.23,.30,.038,'#ddd96c'); // reflective badge
// --- v1.9: photo stone yard below sleepers; configurable tiled texture.
// Upload a grass image in the Shopify section's Grass texture field. It is copied
// into a power-of-two WebGL texture so REPEAT works in WebGL1 on phones.
// Until then the single repeating texture is procedurally drawn and costs no HTTP request.
function grassGroundMesh(){
  const hw=115,hz=80,y=-.044;
  const tile=clamp(Number(root.dataset.floorTileSize)||4,2,20);
  const u=hw*2/tile,v=hz*2/tile;
  const verts=[
    -hw,y,-hz, 0,1,0, 0,0,   hw,y,-hz, 0,1,0, u,0,   hw,y,hz, 0,1,0,u,v,
    -hw,y,-hz, 0,1,0, 0,0,   hw,y,hz, 0,1,0,u,v,     -hw,y,hz, 0,1,0,0,v
  ];
  return mesh(verts);
}
function fallbackGrassCanvas(){
  const c=document.createElement('canvas');c.width=c.height=256;
  const ctx=c.getContext('2d');ctx.fillStyle='#45563a';ctx.fillRect(0,0,256,256);
  let seed=82641;const random=()=>{seed=(1664525*seed+1013904223)>>>0;return seed/4294967296};
  // Dense tiny grass blades; stable, not continuously regenerated.
  for(let i=0;i<10800;i++){
    const x=random()*256,y=random()*256;
    const green=46+Math.floor(random()*46),red=27+Math.floor(random()*39),blue=22+Math.floor(random()*24);
    ctx.strokeStyle=`rgba(${red},${green},${blue},${(.13+random()*.52).toFixed(2)})`;
    ctx.lineWidth=.4+random()*1.4;
    ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(x+(random()-.5)*3,y-1-random()*5);ctx.stroke();
  }
  // Repeat marks across opposite edges so the raster doesn't have bright seams.
  for(let i=0;i<260;i++){
    const x=random()*256,y=random()*256;
    const col=random()>.5?'rgba(145,154,91,.18)':'rgba(20,43,20,.25)';
    ctx.fillStyle=col;
    for(const dx of [-256,0,256])for(const dy of [-256,0,256]){
      ctx.beginPath();ctx.ellipse(x+dx,y+dy,1+random()*2,1+random()*2,0,0,TAU);ctx.fill();
    }
  }
  return c;
}
const yardGrass={shape:grassGroundMesh(),pos:[0,0,0],size:[1,1,1],rot:0,color:[1,1,1],metal:0,ground:true,tex:gl.createTexture()};
function uploadGrass(canvas){
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,yardGrass.tex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.REPEAT);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.REPEAT);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR_MIPMAP_LINEAR);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,canvas);
  gl.generateMipmap(gl.TEXTURE_2D);
}
uploadGrass(fallbackGrassCanvas());
scene.push(yardGrass);
if(root.dataset.floorUrl){
  const img=new Image();img.crossOrigin='anonymous';
  img.onload=()=>{
    const c=document.createElement('canvas');c.width=c.height=512;
    const ctx=c.getContext('2d');ctx.drawImage(img,0,0,512,512);
    uploadGrass(c);
  };
  img.onerror=()=>console.warn('GBattle yard texture could not load: keeping procedural tile');
  img.src=root.dataset.floorUrl;
}
// v2.2 — single-image panorama per wall: 1 opposite 3, 2 opposite 4.
// Normals face into the playable yard; walls are NOT spray targets.
const gb3Backdrop=[];
function gb3BackdropPlane(x,y,z,w,h,rotation,name){
 const o={shape:plane,pos:[x,y,z],size:[w,h,1],rot:rotation,color:[1,1,1],metal:0,backdrop:true,importTex:gl.createTexture(),name};
 gb3Backdrop.push(o);scene.push(o);
 gl.bindTexture(gl.TEXTURE_2D,o.importTex);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([92,159,213,255]));
 return o;
}
function gb3BackdropImage(o,url){
 if(!url)return;const image=new Image();image.crossOrigin='anonymous';
 image.onload=()=>{const cv=document.createElement('canvas');const scale=Math.min(1,1024/image.width);
 cv.width=Math.round(image.width*scale);cv.height=Math.round(image.height*scale);
 cv.getContext('2d').drawImage(image,0,0,cv.width,cv.height);
 gl.bindTexture(gl.TEXTURE_2D,o.importTex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,cv);
 };
 image.onerror=()=>console.warn('GBattle wall image failed:',o.name,url,'— confirm the jpg is uploaded to Shopify Assets.');image.src=url;
}
const gb3W1=gb3BackdropPlane(0,37.5,-79,226,75,0,'Wall 1 — north');
const gb3W3=gb3BackdropPlane(0,37.5,79,226,75,Math.PI,'Wall 3 — south');
const gb3W2=gb3BackdropPlane(113,37.5,0,158,75,-Math.PI/2,'Wall 2 — east');
const gb3W4=gb3BackdropPlane(-113,37.5,0,158,75,Math.PI/2,'Wall 4 — west');
// Cut true openings into east and west image walls so train cars can pass
// through them. UVs sample the SAME original photograph with no image repeats.
// The opening covers z=-4.4..4.4, ground to 7.2m, large enough for C30.
function gb3WallPatch(master,u0,v0,u1,v1){
 const quadPart=[
   u0-.5,v0-.5,0,0,0,1,u0,v0,  u1-.5,v0-.5,0,0,0,1,u1,v0,
   u1-.5,v1-.5,0,0,0,1,u1,v1,  u0-.5,v0-.5,0,0,0,1,u0,v0,
   u1-.5,v1-.5,0,0,0,1,u1,v1,  u0-.5,v1-.5,0,0,0,1,u0,v1
 ];
 scene.push({shape:mesh(quadPart),pos:master.pos,size:master.size,rot:master.rot,
   color:[1,1,1],metal:0,backdrop:true,importTex:master.importTex});
}
for(const master of [gb3W2,gb3W4]){
 const i=scene.indexOf(master);if(i>=0)scene.splice(i,1);
 const sideOpening=.5*8.8/158,topOfOpening=7.2/75;
 gb3WallPatch(master,0,0,.5-sideOpening,1);
 gb3WallPatch(master,.5+sideOpening,0,1,1);
 gb3WallPatch(master,.5-sideOpening,topOfOpening,.5+sideOpening,1);
}
// Dark concrete portals around the openings. The dark surfaces behind each
// opening are the inside of the tunnel, not floating props in the sky.
for(const sign of [-1,1]){
 const mouth=sign*112.45;
 box(mouth,3.6,-4.45,1.0,7.2,.85,'#252b31');
 box(mouth,3.6,4.45,1.0,7.2,.85,'#252b31');
 box(mouth,7.2,0,1.15,.65,9.85,'#1d2329');
 box(sign*133,3.5,0,.55,7.05,8.25,'#10141b');
}

// Shopify data-gb3-wall-1-url maps to dataset["gb3Wall-1Url"], NOT
// dataset.gb3Wall1Url: the hyphen before a digit is retained by DOMStringMap.
// Read the literal attribute so numbered walls always resolve reliably.
for(const [n,o] of [[1,gb3W1],[2,gb3W2],[3,gb3W3],[4,gb3W4]]){
 const url=root.getAttribute('data-gb3-wall-'+n+'-url');
 if(url && !/^(?:\s*|undefined|null)$/i.test(url)) gb3BackdropImage(o,url);
 else console.warn('GBattle: missing Wall '+n+' Shopify URL. Update sections/3D-graffiti.liquid.');
}
// Sky ceiling uses the tiny user-provided BLUE TILE with repeating UVs.
const gb3SkyShape=mesh([
 -113,75,-79,0,-1,0,0,0,113,75,-79,0,-1,0,24,0,113,75,79,0,-1,0,24,17,
 -113,75,-79,0,-1,0,0,0,113,75,79,0,-1,0,24,17,-113,75,79,0,-1,0,0,17]);
const gb3Sky={shape:gb3SkyShape,pos:[0,0,0],size:[1,1,1],rot:0,color:[1,1,1],metal:0,backdrop:true,importTex:gl.createTexture(),name:'Tiled Sky'};
scene.push(gb3Sky);
function gb3SkyTile(image){
 const cv=document.createElement('canvas');cv.width=cv.height=256;const ctx=cv.getContext('2d');
 // Make a power-of-two repeating texture, preserving the tile image.
 ctx.drawImage(image,0,0,256,256);
 gl.bindTexture(gl.TEXTURE_2D,gb3Sky.importTex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.REPEAT);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.REPEAT);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,cv);
}
{const fallback=document.createElement('canvas');fallback.width=fallback.height=256;fallback.getContext('2d').fillStyle='#58a7ef';fallback.getContext('2d').fillRect(0,0,256,256);gb3SkyTile(fallback)}
if(root.dataset.gb3SkyUrl){const skyImg=new Image();skyImg.crossOrigin='anonymous';skyImg.onload=()=>gb3SkyTile(skyImg);skyImg.src=root.dataset.gb3SkyUrl;}


// GB3_WORLD_YARD_V1: Alternate playable environments use procedural meshes; no train GLBs modified.
// Save the existing yard/guard scene as drawn. Each environment has its own cover objects.
for(const o of scene)if(!o.guard)o.gb3Map='yard';
let gb3ActiveMap=(new URLSearchParams(location.search).get('gb3map')||'yard').toLowerCase();
if(!['yard','depot','tunnel'].includes(gb3ActiveMap))gb3ActiveMap='yard';
const gb3TrafficCars=[];
function gb3Track(z,span=224){
 for(const r of [-1.02,1.02]){
  box(0,.13,z+r,span,.16,.17,'#adb5b3',1);
  box(0,.24,z+r+.19,span,.027,.045,'#75878a',1);
 }
 // Sleepers grouped into a single GPU buffer, preserving Android performance.
 const a=[],template=faces();
 for(let x=-span/2;x<span/2;x+=1.2){
  for(let i=0;i<template.length;i+=8)a.push(x+template[i]*.27,-.02+template[i+1]*.16,z+template[i+2]*3.2,template[i+3],template[i+4],template[i+5],template[i+6],template[i+7]);
 }
 scene.push({shape:mesh(a),pos:[0,0,0],size:[1,1,1],rot:0,color:hex('#51463d'),metal:0});
}
function gb3MapBounds(){
 if(gb3ActiveMap==='tunnel')return {minX:-90,maxX:90,minZ:-12.8,maxZ:5.8};
 if(gb3ActiveMap==='depot')return {minX:-81,maxX:81,minZ:-24.5,maxZ:24.5};
 return {minX:-82,maxX:82,minZ:-51,maxZ:51};
}
function gb3DepotScene(){
 const st=scene.length;
 // White repair depot with four rail lines and red structural beams.
 box(0,-.34,0,168,.65,66,'#f0f2f1');
 box(0,6.7,-25.5,168,13,.7,'#fbfbfb');
 box(0,6.7,25.5,168,13,.7,'#fbfbfb');
 box(0,13.5,0,168,.4,52.5,'#fbfbfb');
 // Red roof/column structure running front to back.
 for(let x=-78;x<=78;x+=13.5){
  box(x,6.6,-23.85,.58,13.1,.66,'#d94b49');
  box(x,6.6,23.85,.58,13.1,.66,'#d94b49');
 }
 for(const z of [-21,-12,-3,6,15,24]){
  box(0,12.25,z,168,.22,.55,'#d94b49');
 }
 for(const z of [-21,24])box(0,9.5,z,168,.18,.34,'#d94b49');
 // Ceiling light strips.
 for(let x=-72;x<=72;x+=13.5){
  for(const z of [-19.5,-10.5,-1.5,7.5,16.5]){
   box(x,12.95,z,6.8,.11,.85,'#ece9dd');
   box(x,12.86,z,5.9,.05,.42,'#fffff2');
  }
 }
 // Four rail lines: 3 static trains, 1 active center rail.
 const railZ=[-18,0,9,18];
 for(const z of railZ)gb3Track(z,164);
 // Main playable rail service pit.
 box(0,-.025,0,157,.07,1.38,'#272c30');
 for(const z of [-1.55,1.55])box(0,.07,z,155,.10,.09,'#d7b349');
 // Yellow lifting pillars only over line 1 and line 4.
 for(const z of [-18,18]){
  for(let x=-68;x<=68;x+=24){
   box(x,2.7,z-3.1,.92,5.4,.92,'#b18b02');
   box(x,2.7,z+3.1,.92,5.4,.92,'#b18b02');
   box(x,5.42,z,9.2,.42,8.4,'#b18b02');
  }
 }
 // Static trains for lines 1, 3 and 4. They are scenery only and never use the player's paint layer.
 // Actual selected GLB is instanced on the three rails after gb3LoadTrain; no placeholder geometry.
 // Minimal equipment cover kept clear of the new walking corridors.
 for(const [x,z,w,d] of [[-52,23,3.5,2.5],[-24,-23,3.5,2.5],[52,-23,3.5,2.5]]){
  box(x,1.15,z,w,2.3,d,'#d7b349');
  box(x,2.37,z,w+.1,.12,d+.1,'#6d7277');
  gb3Cover.push({x,z,hx:w/2+.1,hz:d/2+.1,kind:'equipment',map:'depot'});
 }
 // Entry frames / hall edges.
 for(const x of [-84,84]){
  box(x,7.7,-12.75,.6,10,22.5,'#d94b49');
  box(x,7.7,12.75,.6,10,22.5,'#d94b49');
  box(x,12.8,0,.6,.55,49.5,'#d94b49');
 }
 for(const o of scene.slice(st))o.gb3Map='depot';
}
// GB3_CAVE_TILED_TEXTURES_V1: only Tunnel Yard; Shopify theme asset URLs, not guessed paths.
// Resample uploaded 627px JPGs into 512x512 power-of-two textures for WebGL1 REPEAT.
function gb3CaveTexture(assetUrl,background,name){
 const tex=gl.createTexture();
 gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tex);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.REPEAT);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.REPEAT);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR_MIPMAP_LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 const rgb=hex(background).map(v=>Math.round(v*255));
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,
   new Uint8Array([rgb[0],rgb[1],rgb[2],255]));
 gl.generateMipmap(gl.TEXTURE_2D);
 if(!assetUrl||/^(?:\s*|undefined|null)$/i.test(assetUrl)){
  console.warn('GBattle: missing '+name+' Shopify Asset URL; keeping tunnel base material');
  return tex;
 }
 const img=new Image();img.crossOrigin='anonymous';
 img.onload=()=>{
  const cv=document.createElement('canvas');cv.width=cv.height=512;
  cv.getContext('2d').drawImage(img,0,0,512,512);
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,cv);
  gl.generateMipmap(gl.TEXTURE_2D);
 };
 img.onerror=()=>console.warn('GBattle: '+name+' image failed; check Shopify Assets: '+assetUrl);
 img.src=assetUrl;
 return tex;
}

function gb3TunnelScene(){
 const st=scene.length;
 // Narrower tunnel footprint so movement stays inside the tunnel envelope.
 box(0,-.34,-3.2,224,.65,22,'#4a4b46');
 // Tiled cave gravel over cave ground only (tracks/walkways remain visible).
 // Real-world 4 m repeats; do not stretch the source image once over 224 m.
 const caveFloorTex=gb3CaveTexture(root.getAttribute('data-gb3-cave-floor-url'),'#4a4b46','cave-floor.jpg');
 const caveFloorY=-.012,caveX=112,caveZa=-14.2,caveZb=7.8;
 const caveFloorUVX=224/4,caveFloorUVZ=22/4;
 const caveFloorVerts=[
  -caveX,caveFloorY,caveZa,0,1,0,0,0,
  caveX,caveFloorY,caveZa,0,1,0,caveFloorUVX,0,
  caveX,caveFloorY,caveZb,0,1,0,caveFloorUVX,caveFloorUVZ,
  -caveX,caveFloorY,caveZa,0,1,0,0,0,
  caveX,caveFloorY,caveZb,0,1,0,caveFloorUVX,caveFloorUVZ,
  -caveX,caveFloorY,caveZb,0,1,0,0,caveFloorUVZ
 ];
 scene.push({shape:mesh(caveFloorVerts),pos:[0,0,0],size:[1,1,1],rot:0,
  color:[1,1,1],metal:0,importTex:caveFloorTex,name:'GB3_CAVE_FLOOR'});
 const shell=[];const cols=20,steps=32;
 for(let k=0;k<steps;k++){
  const x0=-112+k*7,x1=x0+7;
  for(let j=0;j<cols;j++){
   const u=j*Math.PI/cols,v=(j+1)*Math.PI/cols;
   const vertex=(x,t)=>[x,1.1+7.6*Math.sin(t),-3.0+12.6*Math.cos(t)];
   const a=vertex(x0,u),b=vertex(x1,u),c=vertex(x1,v),d=vertex(x0,v);
   const n=[0,-.78,-.24];
   // UV follows tunnel arc length and train direction, for dense seamless tiling.
   const uv0=[x0/4,(u*12.6)/4],uv1=[x1/4,(u*12.6)/4];
   const uv2=[x1/4,(v*12.6)/4],uv3=[x0/4,(v*12.6)/4];
   for(const [p,uv] of [[a,uv0],[b,uv1],[c,uv2],[a,uv0],[c,uv2],[d,uv3]])
    shell.push(...p,...n,...uv);
  }
 }
 const caveWallTex=gb3CaveTexture(root.getAttribute('data-gb3-cave-wall-url'),'#656660','cave-wall.jpg');
 scene.push({shape:mesh(shell),pos:[0,0,0],size:[1,1,1],rot:0,
  color:[1,1,1],metal:0,importTex:caveWallTex,name:'GB3_CAVE_WALL'});
 for(let x=-108;x<=108;x+=12){
  for(const z of [-12.4,4.9]){
   box(x,2.9,z,.22,4.6,.25,'#343638');
   box(x,4.62,z,.35,.22,.4,'#969c93');
  }
  for(const z of [-9.8,-7.3,-4.9])box(x,8.12,z,.32,.11,2.2,'#d0d4c3');
 }
 gb3Track(0);gb3Track(-7.2);
 // Walkways and cable trays brought 50% closer to the train.
 for(const z of [-10.4,2.8]){
  box(0,.16,z,221,.28,1.65,'#6c6e67');
  for(let y=1.9;y<=3.5;y+=.55)box(0,y,z>0?z+.86:z-.86,221,.085,.10,'#818981',1);
  box(0,4.05,z>0?z+.36:z-.36,221,.25,.54,'#43474a',1);
 }
 // Remove the large gap/box clutter; keep only slim shelter columns.
 for(const x of [-60,-18,24,66]){
  box(x,2.25,2.2,1.6,4.5,1.2,'#4e5659');
  box(x,4.56,2.2,1.9,.16,1.5,'#252e32');
  gb3Cover.push({x,z:2.2,hx:.95,hz:.78,kind:'pillar',map:'tunnel'});
 }
 // Tunnel train is drawn as a clean GPU instance of the selected model, never procedural boxes.
 for(const o of scene.slice(st))o.gb3Map='tunnel';
}
gb3DepotScene();gb3TunnelScene();
// Map switch is native and does not reload or clear spray textures.
const gb3MapSelect=document.createElement('select');gb3MapSelect.className='gb3-map-select';
gb3MapSelect.setAttribute('aria-label','Choose train yard map');gb3MapSelect.title='Switch between yards';
for(const [v,label] of [['yard','OUTDOOR YARD'],['depot','REPAIR DEPOT'],['tunnel','TUNNEL YARD']]){
 const option=document.createElement('option');option.value=v;option.textContent=label;gb3MapSelect.appendChild(option);
}
gb3MapSelect.value=gb3ActiveMap;
const gb3MapCSS=document.createElement('style');gb3MapCSS.textContent=`
.gb3-game .gb3-map-select{position:absolute;top:60px;right:10px;z-index:110;max-width:min(48vw,180px);padding:8px;border-radius:7px;background:#142027;color:#fff;border:1px solid #e8c84e;font-size:11px;font-weight:800;letter-spacing:.02em;pointer-events:auto}
.gb3-game.gb3-mobile .gb3-map-select{top:54px;max-width:130px;font-size:10px;padding:6px}`;
root.appendChild(gb3MapCSS);root.appendChild(gb3MapSelect);
gb3MapSelect.addEventListener('change',()=>{
 gb3ActiveMap=gb3MapSelect.value;
 root.dataset.gb3Map=gb3ActiveMap;
 cam.x=3;cam.z=gb3ActiveMap==='tunnel'?5.5:gb3ActiveMap==='depot'?21.8:16.5;
 gb3TunnelTraffic.elapsed=0;gb3TunnelTraffic.state='waiting';gb3TunnelTraffic.next=gb3ActiveMap==='tunnel'?20:90;
 // Current art, train model, WebGL context and cover/patrol system remain intact.
 try{const url=new URL(location.href);url.searchParams.set('gb3map',gb3ActiveMap);history.replaceState(history.state,'',url.toString())}catch(_){}
 toast(gb3ActiveMap==='depot'?'REPAIR DEPOT':gb3ActiveMap==='tunnel'?'TUNNEL YARD':'OUTDOOR YARD');
});
root.dataset.gb3Map=gb3ActiveMap;
const gb3TunnelTraffic={elapsed:0,state:'waiting',next:gb3ActiveMap==='tunnel'?22:90,dir:1,x:-155,horned:false};
function gb3StepTunnelTraffic(dt){
 if(gb3ActiveMap!=='tunnel'||!dt)return;
 const t=gb3TunnelTraffic;
 t.elapsed+=dt;
 if(t.state==='waiting'&&t.elapsed>=t.next){
  t.elapsed=0;t.state='warning';t.dir=Math.random()<.5?1:-1;t.horned=false;
  toast('APPROACHING TRAIN · SECOND TRACK');
 }
 if(t.state==='warning'){
  if(!t.horned){t.horned=true;gb3PlayTrainHorn()}
  if(t.elapsed>3.5){t.elapsed=0;t.state='passing';t.x=-155*t.dir;}
 }
 if(t.state==='passing'){
  t.x+=t.dir*dt*(Math.random()<.002?22:18);
  if(Math.abs(t.x)>165){t.state='waiting';t.elapsed=0;t.next=80+Math.random()*50;}
 }
 // Passing train position is used by gb3DrawSecondaryModels; no duplicate model meshes.
}
// Visible flashlight sweep used by the guard in every playable environment.
const gb3Flashlight={origin:[0,2.2,0],target:[0,1.0,-10]};
const gb3BeamShape=mesh([
  0,2.14,0, 0,1,0, .5,0,  -5.6,.06,-15.5, 0,1,0, 0,1,  5.6,.06,-15.5,0,1,0,1,1,
  0,2.14,0, 0,1,0,.5,0,  5.6,.06,-15.5,0,1,0,1,1, -5.6,.06,-15.5,0,1,0,0,1]);
const gb3Beam={shape:gb3BeamShape,pos:[0,0,0],size:[1,1,1],rot:0,color:hex('#d9e6b5'),metal:0,alpha:.12,beam:true};
function gb3StepFlashlight(){
 if(!gb3Security.active)return;
 const t=gb3Security.elapsed;
 gb3Flashlight.origin=[gb3Security.x,2.2,gb3Security.z];
 gb3Flashlight.target=[gb3Security.x+Math.sin(t*1.8)*8,1,gb3Security.z+9*Math.cos(t*.52)];
 const dx=gb3Flashlight.target[0]-gb3Security.x,dz=gb3Flashlight.target[2]-gb3Security.z;
 gb3Beam.pos[0]=gb3Security.x;gb3Beam.pos[2]=gb3Security.z;
 gb3Beam.rot=-Math.atan2(dx,-dz);
}

// Draw base geometry first, then texture layers using depth-tested alpha blending.
const opaque=scene.filter(x=>!x.panel);
const transparentTrain=[];
// Separate depot/tunnel instances share the exact loaded train geometry (zero extra model downloads).
const gb3Secondary={models:[],shells:[],slots:[-18,9,18],surfaces:[],epoch:0};
// SL C30 source: user-provided SketchUp Collada export, converted to two glTF 2.0 GLBs.
// Public train model assets are loaded from the game asset endpoint.
// Full source geometry and independent UV graffiti overlay, including curved/sloped exterior surfaces.
const C30_BASE='https://gbattle.sweink.com/3d/models/';
const c30LoadStatus={state:'loading',name:''};
// Train A: same imported C30 meshes + fitted graffiti shell, translated
// together. Only its world-space X changes: materials/UVs/paint are untouched.
const TRAIN_END_WALL_X=113,TRAIN_HALF_LENGTH=70.2,TRAIN_TUNNEL_MARGIN=6;
const TRAIN_OFFSCREEN=TRAIN_END_WALL_X+TRAIN_HALF_LENGTH+TRAIN_TUNNEL_MARGIN;
const TRAIN_DWELL_SECONDS=180,TRAIN_TUNNEL_SECONDS=10;
const TRAIN_ENTRY_SECONDS=18,TRAIN_EXIT_SECONDS=18;
const trainMotion={phase:'loading',elapsed:0,x:0};
// Default sound ON. Browser audio starts on the first permitted real gesture.
// User may switch SOUND OFF at any time; we NEVER automatically unmute it.
const gb3Sound={enabled:true,userChoice:false,unlocked:false,playedLoop:false,failed:false};
const gb3SoundButton=document.createElement('button');
gb3SoundButton.type='button';gb3SoundButton.className='gb3-sound-btn';
gb3SoundButton.title='Sound is on by default; playback starts after your first interaction. Click to mute.';
gb3SoundButton.setAttribute('aria-label','Mute train and spray sounds');
(root.querySelector('.top-actions')||root).prepend(gb3SoundButton);
// Models, brushes and audio all use the existing public P20 HTTPS host.
const gb3P20AudioBase=(root.dataset.gb3AudioBase||'https://gbattle.sweink.com/3d/audio/').replace(/\/?$/,'/');
const gb3AudioURLs={
 arrival:[gb3P20AudioBase+'gb3-train-arrival.mp3'],
 journey:[gb3P20AudioBase+'gb3-train-departure.mp3'],
 spray:[gb3P20AudioBase+'gb3-spray-loop.mp3'],
 shake:[gb3P20AudioBase+'gb3-can-shake.mp3'],
 horn:[gb3P20AudioBase+'train-trumpet.mp3']
};
const gb3AudioCtor=window.AudioContext||window.webkitAudioContext;
let gb3AudioContext=null,gb3AudioVolume=null,gb3CurrentSource=null;
let gb3CurrentKey=null,gb3SourceStartedAt=0;
const gb3AudioBuffers={},gb3AudioLoads={},gb3AudioFailedKeys=new Set();
let gb3SprayPainting=false,gb3SpraySource=null,gb3SprayGain=null,gb3NextShakeAt=0;
const gb3ShakeSources=new Set();
function gb3SetSoundLabel(message){
 gb3SoundButton.textContent=message&&message.includes('⚠')?'⚠':(gb3Sound.enabled?'🔊':'🔇');
  if(message)gb3SoundButton.title=message;
  else gb3SoundButton.title=gb3Sound.enabled?'Mute train and spray sounds':'Enable train and spray sounds';
 gb3SoundButton.setAttribute('aria-label',gb3Sound.enabled?'Mute train and spray sounds':'Enable train and spray sounds');
 gb3SoundButton.setAttribute('aria-pressed',String(gb3Sound.enabled));
}
gb3SetSoundLabel();
function gb3ActiveAudio(){
 if(c30LoadStatus.state!=='ready')return null;
 if(trainMotion.phase==='entering'&&!gb3Sound.playedLoop)return ['arrival',trainMotion.elapsed];
 if(['exiting','tunnel','entering'].includes(trainMotion.phase)&&gb3Sound.playedLoop){
  const seconds=trainMotion.phase==='exiting'?trainMotion.elapsed:trainMotion.phase==='tunnel'?18+trainMotion.elapsed:28+trainMotion.elapsed;
  return ['journey',seconds];
 }
 return null;
}
function gb3StopAudio(){
 if(gb3CurrentSource){try{gb3CurrentSource.stop()}catch(_){}try{gb3CurrentSource.disconnect()}catch(_){}}
 gb3CurrentSource=null;gb3CurrentKey=null;
}
function gb3StopSprayAudio(){
 gb3NextShakeAt=0;
 if(gb3SpraySource){
  const source=gb3SpraySource,gain=gb3SprayGain;
  gb3SpraySource=null;gb3SprayGain=null;
  try{
   const now=gb3AudioContext.currentTime;
   gain.gain.cancelScheduledValues(now);
   gain.gain.setValueAtTime(gain.gain.value,now);
   gain.gain.linearRampToValueAtTime(0,now+.075);
   source.stop(now+.085);
  }catch(_){try{source.stop()}catch(_){}}
 }
 // If a shake is in progress when spraying stops, cut it off too.
 for(const node of gb3ShakeSources){
  try{node.stop()}catch(_){}
  try{node.disconnect()}catch(_){}
 }
 gb3ShakeSources.clear();
}
function gb3StopAllAudio(){gb3StopAudio();gb3StopSprayAudio();for(const s of gb3HornSources){try{s.stop()}catch(_){} }gb3HornSources.clear();}
async function gb3DecodeAudio(key){
 if(gb3AudioBuffers[key])return gb3AudioBuffers[key];
 if(gb3AudioLoads[key])return gb3AudioLoads[key];
 if(!gb3AudioContext)return null;
 const order=[...new Set((gb3AudioURLs[key]||[]).filter(Boolean))];
 gb3AudioLoads[key]=(async()=>{
  const problems=[];
  for(const url of order){
   try{
    const resp=await fetch(url,{mode:'cors',credentials:'omit'});
    if(!resp.ok)throw Error('HTTP '+resp.status);
    if((resp.headers.get('content-type')||'').includes('text/html'))throw Error('HTML returned instead of audio');
    const buffer=await resp.arrayBuffer();
    const decoded=await gb3AudioContext.decodeAudioData(buffer);
    if(decoded.duration<(key==='shake'?.15:key==='spray'?1:key==='horn'?1:3))throw Error('Audio track too short');
    gb3AudioBuffers[key]=decoded;
    gb3AudioFailedKeys.delete(key);
    if(gb3Sound.enabled&&gb3AudioFailedKeys.size===0)gb3SetSoundLabel();
    gb3SyncAudio();gb3SyncSprayAudio();return decoded;
   }catch(err){
    problems.push({url,error:String(err?.message||err)});
    console.warn('GBattle: audio URL failed:',key,url,err);
   }
  }
  gb3AudioFailedKeys.add(key);
  if(gb3Sound.enabled)gb3SetSoundLabel('⚠ SOUND FILES');
  gb3SoundButton.title='An audio file could not load. Verify P20 /3d/audio/ and CORS.';
  console.error('GBattle: no playable '+key+' audio found.',problems);
  return null;
 })();
 return gb3AudioLoads[key];
}
function gb3SyncAudio(){
 const active=gb3ActiveAudio();
 if(!gb3Sound.enabled||document.hidden||!gb3AudioContext||gb3AudioContext.state!=='running'||!active){gb3StopAudio();return;}
 const [key,time]=active;
 const buffer=gb3AudioBuffers[key];
 if(!buffer){gb3StopAudio();if(!gb3AudioLoads[key])void gb3DecodeAudio(key);return;}
 const offset=Math.max(0,time);
 if(offset>=buffer.duration-.035){gb3StopAudio();return;}
 if(gb3CurrentSource&&gb3CurrentKey===key&&Math.abs((gb3AudioContext.currentTime-gb3SourceStartedAt)-offset)<1.0)return;
 gb3StopAudio();
 try{
  const source=gb3AudioContext.createBufferSource();source.buffer=buffer;
  source.connect(gb3AudioVolume);source.start(0,offset);
  gb3CurrentSource=source;gb3CurrentKey=key;gb3SourceStartedAt=gb3AudioContext.currentTime-offset;
  source.onended=()=>{if(gb3CurrentSource===source){gb3CurrentSource=null;gb3CurrentKey=null}};
 }catch(err){gb3Sound.failed=true;gb3SetSoundLabel('⚠ SOUND ERROR');console.warn('GBattle: train audio could not start',err)}
}
const gb3HornSources=new Set();
function gb3PlayTrainHorn(){
 if(!gb3Sound.enabled||!gb3AudioContext||gb3AudioContext.state!=='running')return;
 const buffer=gb3AudioBuffers.horn;
 if(!buffer){
  // The train horn can be triggered before CDN audio finishes decoding.
  // Await the existing in-flight load instead of permanently skipping this pass.
  void gb3DecodeAudio('horn').then(decoded=>{
   if(decoded&&gb3ActiveMap==='tunnel'&&
      (gb3TunnelTraffic.state==='warning'||gb3TunnelTraffic.state==='passing')&&
      gb3Sound.enabled&&!document.hidden){gb3PlayTrainHorn();}
  });
  return;
 }
 try{const src=gb3AudioContext.createBufferSource();src.buffer=buffer;
  const gain=gb3AudioContext.createGain();gain.gain.value=.62;
  src.connect(gain);gain.connect(gb3AudioVolume);gb3HornSources.add(src);src.onended=()=>gb3HornSources.delete(src);src.start();
 }catch(err){console.warn('GBattle train horn playback',err)}
}
function gb3PlayShake(){
 const ctx=gb3AudioContext,buffer=gb3AudioBuffers.shake;
 if(!ctx||!buffer||!gb3Sound.enabled||!gb3SprayPainting)return;
 try{
  const source=ctx.createBufferSource();source.buffer=buffer;
  const gain=ctx.createGain();gain.gain.value=.18+Math.random()*.18;
  source.playbackRate.value=.88+Math.random()*.25;
  source.connect(gain);gain.connect(gb3AudioVolume);
  gb3ShakeSources.add(source);
  source.onended=()=>{gb3ShakeSources.delete(source);try{source.disconnect()}catch(_){}};
  source.start();
 }catch(err){console.warn('GBattle: shake effect failed',err)}
}
function gb3SyncSprayAudio(){
 const canPlay=gb3Sound.enabled&&!document.hidden&&gb3AudioContext?.state==='running'&&gb3SprayPainting;
 if(!canPlay){gb3StopSprayAudio();return;}
 if(!gb3AudioBuffers.spray){if(!gb3AudioLoads.spray)void gb3DecodeAudio('spray');return;}
 if(!gb3AudioBuffers.shake&&!gb3AudioLoads.shake)void gb3DecodeAudio('shake');
 if(!gb3SpraySource){
  try{
   const ctx=gb3AudioContext,source=ctx.createBufferSource(),gain=ctx.createGain();
   source.buffer=gb3AudioBuffers.spray;source.loop=true;
   // Fade in/out to avoid clicks when the user releases the spray can.
   gain.gain.setValueAtTime(0,ctx.currentTime);
   gain.gain.linearRampToValueAtTime(.31,ctx.currentTime+.07);
   source.connect(gain);gain.connect(gb3AudioVolume);source.start();
   gb3SpraySource=source;gb3SprayGain=gain;
   gb3NextShakeAt=performance.now()+650+Math.random()*1800;
  }catch(err){console.warn('GBattle: spray effect could not start',err);return;}
 }
 if(performance.now()>=gb3NextShakeAt){
  gb3NextShakeAt=performance.now()+2200+Math.random()*3300;
  if(Math.random()<.8)gb3PlayShake();
 }
}
function gb3SetSprayPainting(active){
 const next=!!active;
 if(gb3SprayPainting===next)return;
 gb3SprayPainting=next;gb3SyncSprayAudio();
}
function gb3EnableAudio(){
 gb3Sound.enabled=true;gb3Sound.failed=false;
 if(!gb3AudioCtor){gb3Sound.failed=true;gb3SetSoundLabel('⚠ AUDIO UNSUPPORTED');return;}
 try{
  if(!gb3AudioContext){
   gb3AudioContext=new gb3AudioCtor();
   gb3AudioVolume=gb3AudioContext.createGain();gb3AudioVolume.gain.value=.65;
   gb3AudioVolume.connect(gb3AudioContext.destination);
  }
  // Called synchronously within a real click, pointerdown or keydown.
  const p=gb3AudioContext.resume();
  gb3Sound.unlocked=true;gb3SetSoundLabel();
  if(p?.then)p.then(()=>{gb3SyncAudio();gb3SyncSprayAudio()}).catch(e=>{gb3Sound.unlocked=false;if(gb3Sound.enabled)gb3SetSoundLabel('🔊 SOUND ON · TAP TO START');console.warn('GBattle: audio unlock failed',e)});
  for(const k of ['arrival','journey','spray','shake','horn'])void gb3DecodeAudio(k);
  gb3SyncAudio();gb3SyncSprayAudio();
 }catch(err){gb3Sound.failed=true;gb3SetSoundLabel('⚠ AUDIO ERROR');console.error('GBattle: audio device error',err)}
}
function gb3DisableAudio(){gb3Sound.enabled=false;gb3StopAllAudio();gb3SetSoundLabel();}
gb3SoundButton.addEventListener('click',e=>{
 e.stopPropagation();gb3Sound.userChoice=true;
 if(gb3Sound.enabled)gb3DisableAudio();else gb3EnableAudio();
});
// Sound starts ON; no extra ENABLE click needed. Browser autoplay policy still
// requires one real interaction to unlock Web Audio on many devices.
root.addEventListener('pointerdown',e=>{
 if(e.target.closest?.('.gb3-sound-btn'))return;
 if(gb3Sound.enabled&&(!gb3AudioContext||gb3AudioContext.state!=='running'))gb3EnableAudio();
},{capture:true});
root.addEventListener('keydown',e=>{
 if(e.repeat)return;
 if(gb3Sound.enabled&&(!gb3AudioContext||gb3AudioContext.state!=='running'))gb3EnableAudio();
},{capture:true});
document.addEventListener('visibilitychange',()=>{
 if(document.hidden){gb3StopAllAudio();gb3SprayPainting=false;}
 else if(gb3Sound.enabled&&gb3AudioContext){
  gb3AudioContext.resume().then(()=>{gb3SyncAudio();gb3SyncSprayAudio()}).catch(()=>gb3SetSoundLabel('🔊 SOUND ON · TAP TO START'));
 }
});
function trainSmooth(t){t=clamp(t,0,1);return t*t*(3-2*t)}
function changeTrainPhase(phase){
 trainMotion.phase=phase;trainMotion.elapsed=0;
 if(phase==='exiting')gb3Sound.playedLoop=true;
 if(phase==='parked')gb3Sound.playedLoop=false;
 gb3SyncAudio();
 if(phase==='entering')trainMotion.x=-TRAIN_OFFSCREEN;
 if(phase==='parked')trainMotion.x=0;
 if(phase==='tunnel')trainMotion.x=TRAIN_OFFSCREEN;
 if(phase!=='parked')stopStroke();
 const hint=$('hint');
 if(phase==='entering')hint.textContent='TRAIN ARRIVING FROM THE TUNNEL';
 if(phase==='parked')hint.textContent='TRAIN PARKED · 3 MINUTES TO PAINT';
 if(phase==='exiting')hint.textContent='TRAIN DEPARTING · WATCH THE TUNNEL';
 if(phase==='tunnel')hint.textContent='TRAIN IN TUNNEL · RETURNING IN 10 SECONDS';
}
function stepTrainMotion(dt){
 if(c30LoadStatus.state!=='ready')return;
 if(!['entering','parked','exiting','tunnel'].includes(trainMotion.phase))return;
 trainMotion.elapsed+=dt;
 if(trainMotion.phase==='entering'){
  const t=trainSmooth(trainMotion.elapsed/TRAIN_ENTRY_SECONDS);
  trainMotion.x=-TRAIN_OFFSCREEN*(1-t);
  if(trainMotion.elapsed>=TRAIN_ENTRY_SECONDS)changeTrainPhase('parked');
 }else if(trainMotion.phase==='parked'){
  // Patrol takes precedence; do not dispatch the train while a guard is outside.
  if(gb3Security.active)return;
  if(trainMotion.elapsed>=TRAIN_DWELL_SECONDS)changeTrainPhase('exiting');
 }else if(trainMotion.phase==='exiting'){
  const t=trainSmooth(trainMotion.elapsed/TRAIN_EXIT_SECONDS);
  trainMotion.x=TRAIN_OFFSCREEN*t;
  if(trainMotion.elapsed>=TRAIN_EXIT_SECONDS)changeTrainPhase('tunnel');
 }else if(trainMotion.phase==='tunnel'){
  if(trainMotion.elapsed>=TRAIN_TUNNEL_SECONDS)changeTrainPhase('entering');
 }
}

async function readGLB(arrayBuffer){
 const dv=new DataView(arrayBuffer);if(arrayBuffer.byteLength<20||dv.getUint32(0,true)!==0x46546c67||dv.getUint32(4,true)!==2)throw Error('Invalid GLB version');
 let p=12,desc=null,bin=null;
 while(p+8<=arrayBuffer.byteLength){const len=dv.getUint32(p,true),kind=dv.getUint32(p+4,true);p+=8;
   if(p+len>arrayBuffer.byteLength)throw Error('Corrupt GLB chunk');
   if(kind===0x4e4f534a)desc=JSON.parse(new TextDecoder().decode(new Uint8Array(arrayBuffer,p,len)));
   if(kind===0x004e4942)bin=new Uint8Array(arrayBuffer,p,len);
   p+=len;
 }
 if(!desc||!bin||desc.asset?.version!=='2.0')throw Error('GLB missing glTF JSON or binary');
 function numbers(accessorId){
   const a=desc.accessors[accessorId],v=desc.bufferViews[a.bufferView];
   if(a.sparse)throw Error('Sparse GLB accessors are unsupported');
   const types={5126:[Float32Array,4],5125:[Uint32Array,4],5123:[Uint16Array,2],5122:[Int16Array,2],5121:[Uint8Array,1],5120:[Int8Array,1]};
   const t=types[a.componentType];if(!t)throw Error('Unsupported GLB component '+a.componentType);
   const fields={SCALAR:1,VEC2:2,VEC3:3,VEC4:4};const count=a.count*fields[a.type];
   const offset=bin.byteOffset+(v.byteOffset||0)+(a.byteOffset||0),width=fields[a.type];
   const stride=v.byteStride||width*t[1],span=a.count?(a.count-1)*stride+width*t[1]:0;
   if(!width||stride<width*t[1]||offset+span>bin.byteOffset+bin.byteLength||(a.byteOffset||0)+span>v.byteLength)throw Error('Out of bounds GLB accessor');
   let raw;
   if(stride===width*t[1])raw=new t[0](bin.buffer.slice(offset,offset+t[1]*count));
   else{
    raw=new t[0](count);const view=new DataView(bin.buffer);
    const getter=({5120:'getInt8',5121:'getUint8',5122:'getInt16',5123:'getUint16',5125:'getUint32',5126:'getFloat32'})[a.componentType];
    for(let row=0;row<a.count;row++)for(let col=0;col<width;col++)raw[row*width+col]=view[getter](offset+row*stride+col*t[1],true);
   }
   if(a.normalized&&a.componentType!==5126){
    const signed=a.componentType===5120||a.componentType===5122;
    const divisor=({5120:127,5121:255,5122:32767,5123:65535,5125:4294967295})[a.componentType];
    if(!divisor)throw Error('Unsupported normalized GLB component');
    return Float64Array.from(raw,v=>signed?Math.max(-1,v/divisor):v/divisor);
   }
   return raw;
 }

 // Preserve the original glTF material textures. Embedded images are loaded from
 // GLB bufferViews; no external model-related requests or hand-drawn decals.
 const gltfTextures=[];
 await Promise.all((desc.images||[]).map((im,index)=>new Promise((resolve,reject)=>{
   if(im.bufferView===undefined){reject(Error('GLB image is not embedded'));return;}
   const view=desc.bufferViews[im.bufferView];
   const blob=new Blob([bin.slice(view.byteOffset||0,(view.byteOffset||0)+view.byteLength)],{type:im.mimeType||'image/png'});
   const url=URL.createObjectURL(blob),image=new Image();
   image.onload=()=>{
     const t=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,t);
     gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,false);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
     gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,image);
     gltfTextures[index]=t;URL.revokeObjectURL(url);resolve();
   };
   image.onerror=()=>{URL.revokeObjectURL(url);reject(Error('Could not decode embedded glTF image '+index));};
   image.src=url;
 })));

 // C6 uses KHR_mesh_quantization with a standard per-mesh node transform;
 // the legacy C30 format remains float32 and is decoded exactly as before.
 const quantized=!!desc.extensionsUsed?.includes('KHR_mesh_quantization');
 const nodeByMesh=new Map();
 {
   for(const node of desc.nodes||[]){
     if(node.mesh!==undefined){
       if(nodeByMesh.has(node.mesh))throw Error('C6 quantized mesh has multiple instances');
       nodeByMesh.set(node.mesh,node);
     }
   }
 }

 const parts=[];
 for(const [meshId,meshDef] of (desc.meshes||[]).entries()){
  for(const prim of meshDef.primitives||[]){
    if(prim.mode!==undefined&&prim.mode!==4)continue;
    const positions=numbers(prim.attributes.POSITION),normals=prim.attributes.NORMAL!==undefined?numbers(prim.attributes.NORMAL):null,uvs=prim.attributes.TEXCOORD_0!==undefined?numbers(prim.attributes.TEXCOORD_0):null;
    const vertexTint=prim.attributes.COLOR_0!==undefined?numbers(prim.attributes.COLOR_0):null;
    const tintFields=vertexTint?(desc.accessors[prim.attributes.COLOR_0].type==='VEC4'?4:3):0;
    const quantNode=nodeByMesh.get(meshId);
    if(quantNode?.matrix||quantNode?.rotation||quantNode?.children)throw Error('Train loader requires baked node rotations and hierarchy');
    const qscale=quantNode?.scale||[1,1,1],qoffset=quantNode?.translation||[0,0,0];
    if(qscale.some(v=>!Number.isFinite(v)||v===0))throw Error('Invalid train node scale');
    const idx=prim.indices!==undefined?numbers(prim.indices):Uint32Array.from({length:positions.length/3},(_,i)=>i);
    // Safeguard mobile devices against unexpectedly huge external GLBs.
    if(idx.length>1800000)throw Error('Train model exceeds safety limit');
    const raw=new Float32Array(idx.length*8),colors=vertexTint?new Float32Array(idx.length*3):null;
    const positionDenominator=quantized&&desc.accessors[prim.attributes.POSITION].componentType===5123&&!desc.accessors[prim.attributes.POSITION].normalized?65535:1;
    const tintToSrgb=c=>c<=.0031308?12.92*c:1.055*Math.pow(c,1/2.4)-.055;
    for(let i=0;i<idx.length;i++){
      const k=idx[i],b=i*8,h=k*3;
      if(h+2>=positions.length)throw Error('Invalid model index');
      raw[b]=qoffset[0]+qscale[0]*positions[h]/positionDenominator;
      raw[b+1]=qoffset[1]+qscale[1]*positions[h+1]/positionDenominator;
      raw[b+2]=qoffset[2]+qscale[2]*positions[h+2]/positionDenominator;
      const nx=normals?normals[h]/qscale[0]:0,ny=normals?normals[h+1]/qscale[1]:1,nz=normals?normals[h+2]/qscale[2]:0;
      const invN=1/(Math.hypot(nx,ny,nz)||1);
      raw[b+3]=nx*invN;raw[b+4]=ny*invN;raw[b+5]=nz*invN;
      raw[b+6]=uvs?uvs[k*2]:0;raw[b+7]=uvs?uvs[k*2+1]:0;
      if(colors)for(let channel=0;channel<3;channel++)colors[i*3+channel]=tintToSrgb(vertexTint[k*tintFields+channel]);
    }
    // A few retained legacy train faces have zero normals. Use their actual
    // triangle normal instead of sending normalize(vec3(0)) into the shader.
    for(let i=0;i<raw.length;i+=24){
     if(Math.hypot(raw[i+3],raw[i+4],raw[i+5])<1e-8||Math.hypot(raw[i+11],raw[i+12],raw[i+13])<1e-8||Math.hypot(raw[i+19],raw[i+20],raw[i+21])<1e-8){
      const ax=raw[i+8]-raw[i],ay=raw[i+9]-raw[i+1],az=raw[i+10]-raw[i+2];
      const bx=raw[i+16]-raw[i],by=raw[i+17]-raw[i+1],bz=raw[i+18]-raw[i+2];
      let nx=ay*bz-az*by,ny=az*bx-ax*bz,nz=ax*by-ay*bx;const length=Math.hypot(nx,ny,nz);
      if(length>1e-12){nx/=length;ny/=length;nz/=length;}else{nx=0;ny=1;nz=0;}
      for(let j=0;j<24;j+=8)if(Math.hypot(raw[i+j+3],raw[i+j+4],raw[i+j+5])<1e-8){raw[i+j+3]=nx;raw[i+j+4]=ny;raw[i+j+5]=nz;}
     }
    }
    const mat=desc.materials?.[prim.material]||{};
    const tint=mat.pbrMetallicRoughness?.baseColorFactor||[.72,.72,.72,1];
    const tid=mat.pbrMetallicRoughness?.baseColorTexture?.index;
    const source=tid===undefined?undefined:desc.textures?.[tid]?.source;
    parts.push({vertices:raw,colors,color:tint.slice(0,3),metal:mat.pbrMetallicRoughness?.metallicFactor||0,alpha:mat.alphaMode==='BLEND'?tint[3]:1,tex:source===undefined?null:gltfTextures[source],name:meshDef.name||''});
  }
 }
 if(!parts.length)throw Error('Model has no supported triangle meshes');
 return parts;
}
// A lightweight spatial AABB check followed by triangle raycasting lets paint follow
// the actual C30 exterior (including doors, glazing, upper panels, ends and roof).
// The train is never recolored/rebuilt when spraying: a separate alpha texture overlay
// is depth-tested against the original train mesh.
function createSurfacePanel(part,idx){
 const name=part.name||('PAINT_surface_'+idx);
 const region=name.includes('roof')?'roof':name.includes('end')?'end':'side';
 const isPhone=isTouchDevice;
 const w=region==='end'?(isPhone?384:512):(isPhone?768:1024);
 const h=region==='end'?w:(isPhone?240:320);
 const p=panel(name,0,1,region==='end'?3.04:8.767,{width:w,pixelHeight:h});
 p.shape=mesh(part.vertices);p.pos=[0,0,0];p.size=[1,1,1];p.rot=0;
 p.surface=true;p.region=region;p.raw=part.vertices;
 let mi=[Infinity,Infinity,Infinity],ma=[-Infinity,-Infinity,-Infinity];
 for(let i=0;i<p.raw.length;i+=8){for(let k=0;k<3;k++){const v=p.raw[i+k];if(v<mi[k])mi[k]=v;if(v>ma[k])ma[k]=v}}
 p.bounds=[mi,ma];return p;
}
// GB3_SECONDARY_INSTANCE_V2: three independently paintable copies of exactly the selected train.
// Their graphics buffers are shared with the original; their paint textures and save keys are not.
function gb3SecondaryKey(slot){return 'gb3-depot-static-v2:'+gb3PaintSaveKey+':rail-'+slot;}
function gb3SecondaryClear(){
 for(const p of gb3Secondary.surfaces){try{gl.deleteTexture(p.tex)}catch(_){}}
 gb3Secondary.models=[];gb3Secondary.shells=[];gb3Secondary.surfaces=[];
 gb3Secondary.epoch++;
}
function gb3SecondaryInit(models,shells){
 gb3SecondaryClear();gb3Secondary.models=models;gb3Secondary.shells=shells;
 // Use the exact source paint geometry/UV but independent low-resolution canvas textures.
 // Same saved artwork stays specific to model identity AND depot rail number.
 for(let slot=0;slot<3;slot++){
  const row=[];
  for(const original of shells){
   const canvas=document.createElement('canvas');
   canvas.width=Math.min(original.canvas.width,isTouchDevice?256:384);
   canvas.height=Math.min(original.canvas.height,isTouchDevice?96:128);
   const ctx=canvas.getContext('2d',{willReadFrequently:true});
   const tex=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,tex);
   gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
   gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,canvas);
   row.push({...original,canvas,ctx,tex,gb3Slot:slot,gb3StaticOffset:gb3Secondary.slots[slot]});
  }
  gb3Secondary.surfaces.push(row);
 }
 if(db)gb3SecondaryRestore();
}
function gb3SecondarySave(){
 if(!db||!['ready','switching'].includes(c30LoadStatus.state)||gb3PaintRestoring)return;
 try{
  const tx=db.transaction('paint','readwrite');const store=tx.objectStore('paint');
  gb3Secondary.surfaces.forEach((row,slot)=>{
   store.put({version:1,created:Date.now(),layers:Object.fromEntries(row.map(p=>[p.name,p.canvas.toDataURL('image/png')]))},gb3SecondaryKey(slot));
  });
 }catch(e){console.warn('GBattle: independent depot paint save failed',e)}
}
function gb3SecondaryRestore(){
 if(!db||!gb3Secondary.surfaces.length)return;
 const epoch=gb3Secondary.epoch,key=gb3PaintSaveKey;
 try{
  for(let slot=0;slot<3;slot++){
   const request=db.transaction('paint','readonly').objectStore('paint').get(gb3SecondaryKey(slot));
   request.onsuccess=()=>{
    if(epoch!==gb3Secondary.epoch||key!==gb3PaintSaveKey)return;
    const saved=request.result;if(saved?.version!==1||!saved.layers)return;
    for(const p of gb3Secondary.surfaces[slot]){
     const url=saved.layers[p.name];if(!url?.startsWith('data:image/png;base64,'))continue;
     const im=new Image();im.onload=()=>{
      if(epoch!==gb3Secondary.epoch||key!==gb3PaintSaveKey)return;
      p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);
      p.ctx.drawImage(im,0,0,p.canvas.width,p.canvas.height);dirty.add(p);
     };im.src=url;
    }
   };
  }
 }catch(e){console.warn('GBattle: independent depot paint restore failed',e)}
}
function gb3SecondaryPaintHit(x,y,dir,best,reach){
 if(gb3ActiveMap!=='depot'||!gb3Secondary.surfaces.length)return best;
 for(const row of gb3Secondary.surfaces){
  for(const p of row){
   const origin=[cam.x,cam.y,cam.z-p.gb3StaticOffset];
   const hit=surfaceHit(origin,dir,p,best?Math.min(best.distance,reach):reach);
   if(hit&&(!best||hit.distance<best.distance)){
    hit.world[2]+=p.gb3StaticOffset;
    best=hit;
   }
  }
 }
 return best;
}
function gb3DrawSecondaryModels(transparent=false){
 if(c30LoadStatus.state!=='ready'||!gb3Secondary.models.length)return;
 if(gb3ActiveMap==='depot'){
  for(const z of gb3Secondary.slots){
   for(const part of gb3Secondary.models){
    if(!!part.translucent!==transparent)continue;
    renderPart({...part,imported:false,gb3SecondaryInstance:true,pos:[0,0,z]});
   }
  }
  if(transparent){
   for(const row of gb3Secondary.surfaces)for(const p of row){
    renderPart({...p,panel:true,surface:false,gb3SecondaryInstance:true,pos:[0,0,p.gb3StaticOffset]});
   }
  }
 }else if(gb3ActiveMap==='tunnel'&&gb3TunnelTraffic.state==='passing'){
  for(const part of gb3Secondary.models){
   if(!!part.translucent!==transparent)continue;
   renderPart({...part,imported:false,gb3SecondaryInstance:true,pos:[gb3TunnelTraffic.x,0,-7.2]});
  }
 }
}
function rayBox(o,d,p,maxDistance){
 let low=.08,high=maxDistance;const b=p.bounds;
 for(let k=0;k<3;k++){
  if(Math.abs(d[k])<1e-9){if(o[k]<b[0][k]-.02||o[k]>b[1][k]+.02)return false;continue}
  let a=(b[0][k]-.02-o[k])/d[k],c=(b[1][k]+.02-o[k])/d[k];
  if(a>c){const x=a;a=c;c=x}low=Math.max(low,a);high=Math.min(high,c);
  if(low>high)return false;
 }return true;
}
function surfaceHit(origin,dir,p,maxDist){
 if(!rayBox(origin,dir,p,maxDist))return null;
 const a=p.raw;let best=maxDist,uu=0,vv=0,wx=0,wy=0,wz=0,hitNormal=null,viewAngle=0;
 for(let i=0;i<a.length;i+=24){
   const x0=a[i],y0=a[i+1],z0=a[i+2];
   const e1x=a[i+8]-x0,e1y=a[i+9]-y0,e1z=a[i+10]-z0;
   const e2x=a[i+16]-x0,e2y=a[i+17]-y0,e2z=a[i+18]-z0;
   const px=dir[1]*e2z-dir[2]*e2y,py=dir[2]*e2x-dir[0]*e2z,pz=dir[0]*e2y-dir[1]*e2x;
   const det=e1x*px+e1y*py+e1z*pz;if(Math.abs(det)<1e-8)continue;
   const inv=1/det,tx=origin[0]-x0,ty=origin[1]-y0,tz=origin[2]-z0;
   const u=(tx*px+ty*py+tz*pz)*inv;if(u<-.0001||u>1.0001)continue;
   const qx=ty*e1z-tz*e1y,qy=tz*e1x-tx*e1z,qz=tx*e1y-ty*e1x;
   const v=(dir[0]*qx+dir[1]*qy+dir[2]*qz)*inv;if(v<-.0001||u+v>1.0001)continue;
   const t=(e2x*qx+e2y*qy+e2z*qz)*inv;
   if(t>.08&&t<best){best=t;const b=1-u-v;
     uu=a[i+6]*b+a[i+14]*u+a[i+22]*v;
     vv=a[i+7]*b+a[i+15]*u+a[i+23]*v;
     wx=origin[0]+dir[0]*t;wy=origin[1]+dir[1]*t;wz=origin[2]+dir[2]*t;
      const nx=e1y*e2z-e1z*e2y,ny=e1z*e2x-e1x*e2z,nz=e1x*e2y-e1y*e2x;
      const invN=1/(Math.hypot(nx,ny,nz)||1),facing=nx*dir[0]+ny*dir[1]+nz*dir[2]>0?-1:1;
      hitNormal=[nx*invN*facing,ny*invN*facing,nz*invN*facing];
      // Projection of the camera's spray ray onto the 3D face. Convert its
      // surface-tangent direction to the paint shell's pixel UV axes so grazing
      // marks smear along the VIEWING direction rather than mouse travel.
      const nDot=dir[0]*hitNormal[0]+dir[1]*hitNormal[1]+dir[2]*hitNormal[2];
      const sx=dir[0]-nDot*hitNormal[0],sy=dir[1]-nDot*hitNormal[1],sz=dir[2]-nDot*hitNormal[2];
      const aa=e1x*e1x+e1y*e1y+e1z*e1z,bb=e1x*e2x+e1y*e2y+e1z*e2z,cc=e2x*e2x+e2y*e2y+e2z*e2z;
      const dd=sx*e1x+sy*e1y+sz*e1z,ee=sx*e2x+sy*e2y+sz*e2z,detUV=aa*cc-bb*bb;
      if(detUV>1e-12){
       const ta=(dd*cc-ee*bb)/detUV,tb=(ee*aa-dd*bb)/detUV;
       const du=(ta*(a[i+14]-a[i+6])+tb*(a[i+22]-a[i+6]))*p.canvas.width;
       const dv=-(ta*(a[i+15]-a[i+7])+tb*(a[i+23]-a[i+7]))*p.canvas.height;
       viewAngle=du*du+dv*dv>1e-8?Math.atan2(dv,du):0;
      }else viewAngle=0;
   }
 }
 return best<maxDist?{p,distance:best,u:clamp(uu,0,1),v:clamp(1-vv,0,1),world:[wx,wy,wz],normal:hitNormal,ray:dir,viewAngle}:null;
}
// Change trains without navigating away from the yard or resetting WebGL.
// The old train stays on screen while both assets are downloaded and decoded.
// C6 always requests fresh bytes on both desktop and Android (same stable filenames).
let gb3ModelEpoch=0;
let gb3TrainWalkBounds=null;
function gb3TrainOccupies(x,z){
 if(!gb3TrainWalkBounds||c30LoadStatus.state!=='ready')return false;
 const b=gb3TrainWalkBounds;
 const inside=(shift,side)=>x>shift+b.minX-.62&&x<shift+b.maxX+.62&&
        z>side+b.minZ-.55&&z<side+b.maxZ+.55;
 if(gb3ActiveMap==='depot'&&gb3Secondary.slots.some(rail=>inside(0,rail)))return true;
 return trainMotion.phase!=='tunnel'&&inside(trainMotion.x,0);
}

async function gb3LoadTrain(target=gb3TrainSelection,swapping=false){
 const id=gb3KeyToPublic[target]||target;
 const train=gb3TrainRegistry[id];
 if(!train)throw Error('Unknown requested train: '+String(target));
 const trainKey=train.key,trainName=train.name,saveKey=train.save;
 const previousState=c30LoadStatus.state;
 const size=isTouchDevice?'mobile':'desktop';
 const modelFile=train.models?train.models[size]:train.model;
 const paintFile=train.paint;
 c30LoadStatus.state=swapping?'switching':'loading';
 try{
  const fresh=String(Date.now());
  async function fetchModel(file){
   // C30 existing cache policy stays unchanged; newer stable filenames refresh.
   const refresh=trainKey!=='c30';
   const url=C30_BASE+file+(refresh?'?fresh='+fresh:'');
   const response=await fetch(url,{mode:'cors',credentials:'omit',cache:refresh?'no-store':'default'});
   if(!response.ok)throw Error('Unable to load '+file+' (HTTP '+response.status+')');
   return response.arrayBuffer();
  }
  // Original C6/C30/London keep their existing two-file loader unchanged.
  // Paris MP-73 and Santiago NS-74 carry base mesh, embedded materials and PAINT_ geometry in one GLB.
  const [shellBuffer,modelBuffer]=train.combined?[null,await fetchModel(modelFile)]:await Promise.all([fetchModel(paintFile),fetchModel(modelFile)]);
  const combinedParts=train.combined?await readGLB(modelBuffer):null;
  const shells=train.combined?combinedParts.filter(p=>p.name.startsWith('PAINT_')):await readGLB(shellBuffer);
  if((trainKey==='c30'||trainKey==='c6')?(shells.length<50||shells.length>100):(shells.length!==50))throw Error(trainName+' paint surface is incomplete');
  if(shells.length<30)throw Error(trainName+' paint surface is incomplete');
  const parts=train.combined?combinedParts.filter(p=>!p.name.startsWith('PAINT_')):await readGLB(modelBuffer);
  if(!parts.length)throw Error('Empty train model: '+modelFile);
  // Compute the actual occupied footprint of THIS train (not C30's former fixed 144m barrier).
  const nextWalkBounds={minX:Infinity,maxX:-Infinity,minZ:Infinity,maxZ:-Infinity};
  for(const p of parts){const v=p.vertices;for(let i=0;i<v.length;i+=8){
   nextWalkBounds.minX=Math.min(nextWalkBounds.minX,v[i]);
   nextWalkBounds.maxX=Math.max(nextWalkBounds.maxX,v[i]);
   nextWalkBounds.minZ=Math.min(nextWalkBounds.minZ,v[i+2]);
   nextWalkBounds.maxZ=Math.max(nextWalkBounds.maxZ,v[i+2]);
  }}
  if(!Number.isFinite(nextWalkBounds.minX)||nextWalkBounds.maxX-nextWalkBounds.minX<1)throw Error('Invalid train collision bounds');
  const linearToSrgb=c=>c<=.0031308?12.92*c:1.055*Math.pow(c,1/2.4)-.055;
  const modelParts=parts.map(part=>({shape:mesh(part.vertices,part.colors),pos:[0,0,0],size:[1,1,1],
   color:part.color.map(linearToSrgb),metal:part.metal,rot:0,imported:true,
   importTex:part.tex||null,alpha:part.alpha,translucent:part.alpha<.999}));
  // Prepare the matching graffiti layers without altering the currently visible train.
  const previousPanels=panels;
  let preparedPanels;
  panels=[];
  try{
   shells.forEach((part,i)=>createSurfacePanel(part,i));
   preparedPanels=panels;
  }catch(err){
   for(const p of panels){gl.deleteTexture(p.tex);gb3DeleteMesh(p.shape);}
   for(const o of modelParts)gb3DeleteMesh(o.shape);
   panels=previousPanels;
   throw err;
  }
  panels=previousPanels;
  // Atomic model swap: the WebGL context, camera, UI and yard stay alive.
  const oldTrain=opaque.filter(o=>o.imported).concat(transparentTrain);
  const oldTextures=new Set(oldTrain.map(o=>o.importTex).filter(Boolean));
  const oldYard=opaque.filter(o=>!o.imported);
  stopStroke();gb3SecondarySave();clearTimeout(saveTimer);
  dirty.clear();wetPools.length=0;activeDrips.length=0;undo=[];
  panels=preparedPanels;
  gb3TrainWalkBounds=nextWalkBounds;
  opaque.splice(0,opaque.length,...oldYard,...modelParts.filter(o=>!o.translucent));
  transparentTrain.splice(0,transparentTrain.length,...modelParts.filter(o=>o.translucent));
  for(const p of previousPanels){gl.deleteTexture(p.tex);gb3DeleteMesh(p.shape);}
  for(const o of oldTrain)gb3DeleteMesh(o.shape);
  for(const t of oldTextures)gl.deleteTexture(t);
  gb3TrainSelection=trainKey;
  gb3TrainName=trainName;
  gb3PaintSaveKey=saveKey;
  gb3SecondaryInit(modelParts,preparedPanels);
  root.dataset.gb3Train=trainKey;
  c30LoadStatus.state='ready';c30LoadStatus.name=modelFile;
  gb3ModelEpoch++;
  strokes=0;
  $('paintedCount').textContent='0 strokes';
  $('undoCount').textContent='0 / 7';
  $('saveState').textContent='LOCAL ONLY';
  // In-game changes park the replacement train immediately, with no fade to black.
  changeTrainPhase(swapping?'parked':'entering');
  const caughtText=gb3Caught.querySelector('.gb3-caught-card span');
  if(caughtText)caughtText.textContent='Your graffiti was cleared. The '+trainName+' stays parked.';
  gb3RestoreTrainPaint(saveKey,gb3ModelEpoch);
  toast(trainName+' ready'); // Never expose file types or source formats to players.
  console.info('GBattle 3D: active train',trainName,'model fetched',modelFile,'bytes',modelBuffer.byteLength,
   'cache mode',trainKey!=='c30'?'no-store':'default');
  return true;
 }catch(err){
  c30LoadStatus.state=swapping&&previousState==='ready'?'ready':'error';
  if(c30LoadStatus.state==='error')c30LoadStatus.name=String(err.message||err);
  console.error('GBattle '+trainName+' failed to load:',err);
  if(c30LoadStatus.state==='error')$('hint').textContent=trainName+' UNAVAILABLE · CHECK TRAIN CONNECTION';
  toast(trainName+' could not load. '+(swapping?'Current train kept.':'Please try again.'));
  return false;
 }
}
// Initial train loads once. Later selection uses this same function in-place.
setTimeout(()=>{void gb3LoadTrain(gb3TrainSelection,false)},0);
function bindShape(m){gl.bindBuffer(gl.ARRAY_BUFFER,m.buf);gl.enableVertexAttribArray(loc.p);gl.vertexAttribPointer(loc.p,3,gl.FLOAT,false,32,0);gl.enableVertexAttribArray(loc.n);gl.vertexAttribPointer(loc.n,3,gl.FLOAT,false,32,12);gl.enableVertexAttribArray(loc.uv);gl.vertexAttribPointer(loc.uv,2,gl.FLOAT,false,32,24);if(m.tintBuf){gl.bindBuffer(gl.ARRAY_BUFFER,m.tintBuf);gl.enableVertexAttribArray(loc.tint);gl.vertexAttribPointer(loc.tint,3,gl.FLOAT,false,12,0);}else{gl.disableVertexAttribArray(loc.tint);gl.vertexAttrib3f(loc.tint,1,1,1);}}
function renderPart(o){if(o.gb3Map&&o.gb3Map!==gb3ActiveMap)return;if(o.gb3MovingTunnel&&gb3TunnelTraffic.state!=='passing')return;if(o.guard&&!gb3Security.active)return;if((o.imported||o.surface)&&trainMotion.phase==='tunnel')return;bindShape(o.shape);const drawPos=(o.imported||o.surface)?[o.pos[0]+trainMotion.x,o.pos[1],o.pos[2]]:o.pos;gl.uniformMatrix4fv(loc.model,false,model(drawPos,o.size,o.rot));gl.uniform3fv(loc.color,o.color);gl.uniform1f(loc.metal,o.metal);gl.uniform1f(loc.hasTex,(o.panel||o.ground||o.decal||o.importTex)?1:0);gl.uniform1f(loc.opacity,o.alpha??1);gl.uniform1f(loc.train,o.imported||o.surface||o.gb3SecondaryInstance?1:0);gl.uniform1f(loc.backdrop,o.backdrop?1:0);if(o.panel||o.ground||o.decal||o.importTex){gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,o.importTex||o.tex);gl.uniform1i(loc.texture,0)}/* Respect original double-sided SketchUp face materials. Do not enable
 backface culling for C6: it can remove source roof and front faces. */
if(o.surface||o.gb3SecondaryInstance&&o.panel){gl.enable(gl.POLYGON_OFFSET_FILL);gl.polygonOffset(-1,-1);} gl.drawArrays(gl.TRIANGLES,0,o.shape.count);
 if(o.surface||o.gb3SecondaryInstance&&o.panel)gl.disable(gl.POLYGON_OFFSET_FILL);
}
// Spray Engine R3 configuration. Values in METRES for reach/stand-off;
// texture pixels/second for speed response. Adjust only these numbers when tuning.
const gb3SprayConfig=Object.freeze({
 sprayReach:3.2,        // Max distance from player's eye to the paint surface
 markerReach:1.45,     // Marker requires touching/standing close
 washerReach:2.2,     // Washer requires physical proximity
 spreadStart:0.9,      // Spray begins to broaden after 0.9m
 spreadFull:3.2,       // Spray reaches its widest usable footprint at 3.2m
 spreadNear:0.85,      // Close spray width relative to cap size
 spreadFar:1.55,       // Farthest spray width relative to cap size (old: 2.47)
 offAxisWiden:0.68,    // Extra 0%-68% widen at the edge of the camera view
 offAxisPower:1.45,   // Stronger widening toward screen edges (higher = later onset)
 maxViewSpread:2.15,  // Safety clamp for combined stand-off and edge widening
 speedSoftStart:260,   // Below this, motion never thins the line
 speedFull:1900,       // Requires a genuine fast flick to reach maximum speed effect
 speedPinch:0.58,      // At full speed + FLARE 100%, width shrinks by up to 58%
 speedDensityDrop:0.42,// At full speed, paint flux lightens by up to 42%
 cameraHeight:1.09,    // Original 2.18m: now half-height
 minCameraHeight:0.65, // Lower movement/ducking limit
 maxCameraHeight:6.5
});
function gb3ReachForTool(){return state.tool==='marker'?gb3SprayConfig.markerReach:state.tool==='wash'?gb3SprayConfig.washerReach:gb3SprayConfig.sprayReach;}
let cam={x:1.7,y:gb3SprayConfig.cameraHeight,z:gb3ActiveMap==='tunnel'?5.5:gb3ActiveMap==='depot'?21.8:16.5,yaw:0,pitch:-.025}, speed=5.72, quality=1, fog=1;
// Timed security gameplay: one patrol every eight minutes of play, starting
// with the first parked train. Patrol only runs with a stationary train.
const gb3LocalQAMode=(location.hostname==='localhost'||location.hostname==='127.0.0.1'||window.Shopify?.designMode===true)&&new URLSearchParams(location.search).has('gb3_patrol_test');
const GB3_SECURITY_INTERVAL=gb3LocalQAMode?12:480,GB3_PATROL_SECONDS=gb3LocalQAMode?18:48;
const gb3Security={active:false,started:false,cooldown:GB3_SECURITY_INTERVAL,
  elapsed:0,x:-67,z:7.7,dir:1,detectedFor:0,noticeElapsed:0,patrolDuration:GB3_PATROL_SECONDS};
const gb3Status=document.createElement('div');gb3Status.className='gb3-security-status';
gb3Status.setAttribute('role','status');gb3Status.setAttribute('aria-live','polite');
gb3Status.textContent=gb3LocalQAMode?'SECURITY · QA PATROL IN 0:12':'SECURITY · PATROL IN 8:00';root.appendChild(gb3Status);
const gb3Caught=document.createElement('div');gb3Caught.className='gb3-caught-overlay';gb3Caught.hidden=true;
gb3Caught.innerHTML='<div class="gb3-caught-card"><strong>SECURITY CAUGHT YOU</strong><span>Your graffiti was cleared. The '+gb3TrainName+' stays parked.</span><button type="button">TRY AGAIN</button></div>';
root.appendChild(gb3Caught);gb3Caught.querySelector('button').addEventListener('click',()=>gb3Caught.hidden=true);
function gb3CircleBoxHit(cx,cz,cover,pad){return Math.abs(cx-cover.x)<cover.hx+pad&&Math.abs(cz-cover.z)<cover.hz+pad;}
function gb3InCoverBox(cx,cz){return gb3Cover.some(c=>(!c.map&&gb3ActiveMap==='yard'||c.map===gb3ActiveMap)&&gb3CircleBoxHit(cx,cz,c,.55))}
function gb3Occluded(ax,az,bx,bz){
 // Segment vs expanded AABB: a shed/crate blocks the guard's direct view.
 return gb3Cover.some(c=>{
  if(!(!c.map&&gb3ActiveMap==='yard'||c.map===gb3ActiveMap))return false;
  let lo=0,hi=1;
  for(const [a,b,min,max] of [[ax,bx,c.x-c.hx,c.x+c.hx],[az,bz,c.z-c.hz,c.z+c.hz]]){
   const d=b-a;if(Math.abs(d)<1e-8){if(a<min||a>max)return false;continue;}
   let t0=(min-a)/d,t1=(max-a)/d;if(t0>t1){let s=t0;t0=t1;t1=s;}
   lo=Math.max(lo,t0);hi=Math.min(hi,t1);if(lo>hi)return false;
  }
  return hi>0.02&&lo<.98;
 });
}
function gb3GuardSeePlayer(){
 const dx=cam.x-gb3Security.x,dz=cam.z-gb3Security.z;
 const range=Math.hypot(dx,dz);
 if(range>17||range<.01)return false;
 const lookX=gb3Flashlight.target[0]-gb3Flashlight.origin[0],lookZ=gb3Flashlight.target[2]-gb3Flashlight.origin[2];
 const inv=1/(Math.hypot(lookX,lookZ)||1);
 if((dx*lookX+dz*lookZ)*inv/range<.45)return false;
 return !gb3Occluded(gb3Security.x,gb3Security.z,cam.x,cam.z);
}
function gb3SetGuardPositions(){
 const step=Math.sin(gb3Security.elapsed*10)*.13;
 gb3GuardMeshes.forEach((o,i)=>{
  o.pos[0]=gb3Security.x+o.guardOffset[0];
  o.pos[1]=o.guardOffset[1]+(i===5?step:i===6?-step:0);
  o.pos[2]=gb3Security.z+o.guardOffset[2];
 });
}
function gb3ClearPaintingOnCatch(){
 // Do not ask for confirmation: this is the loss condition. Do not restart
 // the train or change its model, and invalidate locally saved paint.
 stopStroke();gb3SecondarySave();clearTimeout(saveTimer);wetPools.length=0;activeDrips.length=0;
 for(const p of panels){p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);dirty.add(p)}
 undo=[];strokes=0;$('paintedCount').textContent='0 strokes';$('undoCount').textContent='0 / 7';
 if(db){try{const tx=db.transaction('paint','readwrite');tx.objectStore('paint').delete(gb3PaintSaveKey);tx.objectStore('paint').delete('session')}catch(_){}}
 // Deleting the save must NOT immediately write a blank saved session again.
 $('saveState').textContent='ARTWORK LOST';
 gb3Security.active=false;gb3Security.started=true;gb3Security.cooldown=GB3_SECURITY_INTERVAL;gb3Security.detectedFor=0;
 // Freeze at present station; caught does not cause a new moving train cycle.
 trainMotion.phase='parked';trainMotion.x=0;trainMotion.elapsed=0;
 gb3SyncAudio();
 cam={x:1.7,y:gb3SprayConfig.cameraHeight,z:16.5,yaw:0,pitch:-.025};
 gb3Caught.hidden=false;gb3Status.textContent='SECURITY · CAUGHT · ARTWORK LOST';
 toast('Caught! Graffiti cleared. Train remains parked.');
}
function gb3StepSecurity(dt){
 if(c30LoadStatus.state!=='ready'||gb3Caught.hidden===false)return;
 if(!gb3Security.started){if(trainMotion.phase!=='parked')return;gb3Security.started=true;}
 if(!gb3Security.active){
  gb3Security.cooldown=Math.max(0,gb3Security.cooldown-dt);
  if(gb3Security.cooldown===0&&trainMotion.phase==='parked'){
   gb3Security.active=true;gb3Security.elapsed=0;gb3Security.detectedFor=0;
   gb3Security.dir=1;gb3Security.x=-67;gb3Security.z=7.7;
   gb3Security.patrolDuration=GB3_PATROL_SECONDS*(Math.random()<.4?.65:1.0);
   stopStroke();toast('SECURITY PATROL! Hide behind the crates or shed.');
  }
 }else{
  gb3Security.elapsed+=dt;
  const t=Math.min(1,gb3Security.elapsed/gb3Security.patrolDuration);
  gb3Security.x=-67+134*t;
  gb3SetGuardPositions();gb3StepFlashlight();
  if(gb3GuardSeePlayer()){
   gb3Security.detectedFor+=dt;
   if(gb3Security.detectedFor>=1.15){gb3ClearPaintingOnCatch();return;}
  }else gb3Security.detectedFor=Math.max(0,gb3Security.detectedFor-dt*1.5);
  if(t>=1){gb3Security.active=false;gb3Security.cooldown=GB3_SECURITY_INTERVAL;
   gb3Security.detectedFor=0;toast('Security patrol has left the yard.');}
 }
 gb3Security.noticeElapsed+=dt;
 if(gb3Security.noticeElapsed>.5){
  gb3Security.noticeElapsed=0;
  if(gb3Security.active)gb3Status.textContent='⚠ SECURITY PATROLLING · HIDE BEHIND COVER';
  else {const whole=Math.ceil(gb3Security.cooldown),m=Math.floor(whole/60),s=whole%60;gb3Status.textContent=`SECURITY · PATROL IN ${m}:${String(s).padStart(2,'0')}`;}
 }
}

let fov=Math.PI/3.1;const defaultFov=fov;let width=1,height=1;
function resize(){let b=view.getBoundingClientRect(),d=Math.min(window.devicePixelRatio||1,1.5)*quality;let w=Math.max(1,Math.round(b.width*d)),h=Math.max(1,Math.round(b.height*d));if(view.width!==w||view.height!==h){view.width=w;view.height=h}width=b.width;height=b.height;gl.viewport(0,0,w,h)}
window.addEventListener('resize',resize);resize();
let past=performance.now(),frames=0,fpsLast=past;
const key=new Set();
root.addEventListener('keydown',e=>{if(['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName))return;key.add(e.key.toLowerCase());if(['w','a','s','d','q','e','r','f',' '].includes(e.key.toLowerCase()))e.preventDefault();if(['1','2','3','4'].includes(e.key))selectTool(['spray','marker','wash','look'][Number(e.key)-1]);if(e.key.toLowerCase()==='z'&&e.ctrlKey)doUndo();if(e.key==='Escape')root.querySelectorAll('.modal').forEach(x=>x.hidden=true)});
root.addEventListener('keyup',e=>key.delete(e.key.toLowerCase()));root.addEventListener('blur',()=>key.clear());
function forward(){let c=Math.cos(cam.pitch);return [Math.sin(cam.yaw)*c,Math.sin(cam.pitch),-Math.cos(cam.yaw)*c]}
function tick(now){if(!root.isConnected)return;const realDt=Math.max(0,(now-past)/1000);let dt=clamp(realDt,0,.06);past=now;const gameDt=!document.hidden&&realDt<=5?realDt:0;if(gb3Caught.hidden)stepTrainMotion(gameDt);gb3StepSecurity(gameDt);let movement=(key.has('shift')?1.7:1)*speed*dt;
 let forwards=(key.has('w')?1:0)-(key.has('s')?1:0),side=(key.has('d')?1:0)-(key.has('a')?1:0);
 forwards+=touchVec.y;side+=touchVec.x;
 if(forwards||side){const ox=cam.x,oz=cam.z;let norm=1/Math.max(1,Math.hypot(forwards,side));cam.x+=movement*norm*(Math.sin(cam.yaw)*forwards+Math.cos(cam.yaw)*side);cam.z+=movement*norm*(-Math.cos(cam.yaw)*forwards+Math.sin(cam.yaw)*side);const bounds=gb3MapBounds();cam.x=clamp(cam.x,bounds.minX,bounds.maxX);cam.z=clamp(cam.z,bounds.minZ,bounds.maxZ);
 // Resolve each axis against the actual selected train's bounds, including while it moves.
 // Once past either END of a short train, the player can cross the tracks freely.
 if(gb3TrainOccupies(cam.x,cam.z)){
  if(!gb3TrainOccupies(ox,cam.z))cam.x=ox;
  if(gb3TrainOccupies(cam.x,cam.z))cam.z=oz;
 }
 if(gb3InCoverBox(cam.x,cam.z)){if(!gb3InCoverBox(ox,cam.z))cam.x=ox;if(gb3InCoverBox(cam.x,cam.z))cam.z=oz;}}
 if(key.has('q'))cam.yaw-=dt*1.0;if(key.has('e'))cam.yaw+=dt*1.0;
 if(root.gb3StepOptionalLook)root.gb3StepOptionalLook(dt);
 if(key.has('r'))cam.y=clamp(cam.y+movement,gb3SprayConfig.minCameraHeight,gb3SprayConfig.maxCameraHeight);if(key.has('f'))cam.y=clamp(cam.y-movement,gb3SprayConfig.minCameraHeight,gb3SprayConfig.maxCameraHeight);
 if(gb3Sound.enabled&&gb3AudioContext){gb3SyncAudio();gb3SyncSprayAudio();}
 gb3StepTunnelTraffic(gameDt);
 resize();gl.clearColor(gb3Security.active?.004:.054,gb3Security.active?.006:.08,gb3Security.active?.009:.109,1);
 gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.useProgram(program);
 gl.uniform1f(loc.night,gb3Security.active?1:0);
 gl.uniform3fv(loc.torchOrigin,gb3Flashlight.origin);gl.uniform3fv(loc.torchTarget,gb3Flashlight.target);
 const dir=forward(),target=[cam.x+dir[0],cam.y+dir[1],cam.z+dir[2]];
 gl.uniformMatrix4fv(loc.projection,false,perspective(fov,view.width/view.height,.07,240));gl.uniformMatrix4fv(loc.view,false,lookAt([cam.x,cam.y,cam.z],target));gl.uniform3fv(loc.camera,[cam.x,cam.y,cam.z]);gl.uniform1f(loc.fog,fog);
 gl.disable(gl.CULL_FACE);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.disable(gl.BLEND);for(let o of opaque)renderPart(o);gb3DrawSecondaryModels(false);
 gl.enable(gl.BLEND);gl.blendFunc(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA);gl.depthMask(false);for(let o of transparentTrain)renderPart(o);for(let o of panels)renderPart(o);gb3DrawSecondaryModels(true);if(gb3Security.active){gl.uniform1f(loc.night,0);renderPart(gb3Beam);gl.uniform1f(loc.night,1);}gl.depthMask(true);gl.disable(gl.BLEND);
 for(const p of dirty){gl.bindTexture(gl.TEXTURE_2D,p.tex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);gl.texSubImage2D(gl.TEXTURE_2D,0,0,0,gl.RGBA,gl.UNSIGNED_BYTE,p.canvas)}dirty.clear();
 frames++;if(now-fpsLast>1300){$('fps').textContent=Math.round(frames*1000/(now-fpsLast))+' FPS';frames=0;fpsLast=now}
 requestAnimationFrame(tick);
}
gl.enable(gl.DEPTH_TEST);requestAnimationFrame(tick);
function screenRay(x,y){let nx=x/width*2-1,ny=1-y/height*2,forwardDir=forward(),right=[Math.cos(cam.yaw),0,Math.sin(cam.yaw)],up=cross(right,forwardDir),t=Math.tan(fov/2);return unit([0,1,2].map(i=>forwardDir[i]+right[i]*nx*t*width/height+up[i]*ny*t));}
function hitTest(x,y){
 if(c30LoadStatus.state!=='ready'||trainMotion.phase!=='parked'||gb3PaintRestoring)return null;
 let d=screenRay(x,y),best=null,origin=[cam.x-trainMotion.x,cam.y,cam.z],reach=gb3ReachForTool();
 for(const p of panels){
   if(p.surface){const hit=surfaceHit(origin,d,p,best?best.distance:reach);if(hit&&(!best||hit.distance<best.distance))best=hit;continue}
   if(Math.abs(d[2])<.001)continue;const dist=(p.pos[2]-cam.z)/d[2];
   if(dist<.1||dist>=reach)continue;const xx=cam.x+d[0]*dist,yy=cam.y+d[1]*dist;
   if(Math.abs(xx-p.cx)>p.len/2||Math.abs(yy-p.pos[1])>p.size[1]/2)continue;
   if(!best||dist<best.distance)best={p,distance:dist,u:(xx-(p.cx-p.len/2))/p.len,v:1-(yy-(p.pos[1]-p.size[1]/2))/p.size[1],world:[xx,yy,p.pos[2]],normal:[0,0,Math.sign(d[2])*-1],ray:d,viewAngle:Math.atan2(-d[1],d[0])};
 }return gb3SecondaryPaintHit(x,y,d,best,reach);
}
const palette=['#f2eee1','#11151c','#f03d42','#ec8740','#eed34d','#54d66b','#3bb7c8','#4177eb','#8d4fe6','#ed62b5','#a9b6bd','#816145'];
const state={tool:'spray',mat:'solid',color:palette[2],size:18,opacity:.68,dust:.35,drips:true,markerVariant:1,flare:.50,sprayThickness:.35};
for(const c of palette){let b=document.createElement('button');b.className='swatch';b.style.background=c;b.title=c;b.type='button';b.setAttribute('aria-label','Choose color '+c);if(c===state.color)b.classList.add('active');b.onclick=()=>gb3SetPickerHex(c,true);$('colors').append(b)}
// Photoshop-inspired HSV picker: saturation/value square + hue strip + editable HEX.
// Solid colors use picker, metallics remain independent and unmodified.
const gb3PickSquare=$('pickSquare'),gb3PickHue=$('pickHue'),gb3PickCross=$('pickCross'),gb3PickHueMark=$('pickHueMark');
const gb3PickPreview=$('pickPreview'),gb3PickHex=$('pickHex');
let gb3HSV={h:0,s:0,v:0},gb3PickerActive=false;
function gb3HsvRgb(h,s,v){
 const c=v*s,x=c*(1-Math.abs((h/60)%2-1)),m=v-c;let a;
 if(h<60)a=[c,x,0];else if(h<120)a=[x,c,0];else if(h<180)a=[0,c,x];
 else if(h<240)a=[0,x,c];else if(h<300)a=[x,0,c];else a=[c,0,x];
 return a.map(n=>Math.round((n+m)*255));
}
function gb3HexRgb(rgb){return '#'+rgb.map(v=>Math.max(0,Math.min(255,v)).toString(16).padStart(2,'0')).join('');}
function gb3RgbHsv(rgb){
 const [r,g,b]=rgb.map(x=>x/255),max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min;
 let h=0;if(d){if(max===r)h=((g-b)/d)%6;else if(max===g)h=(b-r)/d+2;else h=(r-g)/d+4;h=(h*60+360)%360;}
 return {h,s:max===0?0:d/max,v:max};
}
function gb3PickerRender(){
 const {h,s,v}=gb3HSV,hexColor=gb3HexRgb(gb3HsvRgb(h,s,v));
 if(gb3PickSquare){gb3PickSquare.style.background='linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,hsl('+h+' 100% 50%))';}
 if(gb3PickCross){gb3PickCross.style.left=s*100+'%';gb3PickCross.style.top=(1-v)*100+'%';}
 if(gb3PickHueMark)gb3PickHueMark.style.top=h/360*100+'%';
 if(gb3PickPreview)gb3PickPreview.style.background=hexColor;
 if(gb3PickHex&&document.activeElement!==gb3PickHex)gb3PickHex.value=hexColor.toUpperCase();
 state.color=hexColor;
 const mobileColorDot=root.querySelector('[data-gb3-mobile-color-dot]');
 if(mobileColorDot)mobileColorDot.style.backgroundColor=hexColor;
 root.querySelectorAll('.swatch').forEach(b=>b.classList.toggle('active',b.title.toLowerCase()===hexColor.toLowerCase()));
}
function gb3SetPickerHex(hex,activateSolid=false){
 if(!/^#[0-9a-f]{6}$/i.test(hex))return;
 gb3HSV=gb3RgbHsv([1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)));
 gb3PickerRender();if(activateSolid){setMaterial('solid');if(state.tool==='wash'||state.tool==='look')selectTool('spray');}
}
if(gb3PickSquare&&gb3PickHue){
 function gb3PickAt(e,which){
  const b=which.getBoundingClientRect();if(!b.width||!b.height)return;
  const x=Math.max(0,Math.min(1,(e.clientX-b.left)/b.width));
  const y=Math.max(0,Math.min(1,(e.clientY-b.top)/b.height));
  if(which===gb3PickSquare){gb3HSV.s=x;gb3HSV.v=1-y}else gb3HSV.h=y*359.999;
  gb3PickerRender();setMaterial('solid');
  if(state.tool==='wash'||state.tool==='look')selectTool('spray');
 }
 for(const el of [gb3PickSquare,gb3PickHue]){
  el.addEventListener('pointerdown',e=>{e.preventDefault();el.setPointerCapture(e.pointerId);gb3PickAt(e,el)});
  el.addEventListener('pointermove',e=>{if(e.buttons||e.pressure>0)gb3PickAt(e,el)});
  el.addEventListener('keydown',e=>{
   const delta=(e.key==='ArrowUp'||e.key==='ArrowRight')?1:(e.key==='ArrowDown'||e.key==='ArrowLeft')?-1:0;
   if(!delta)return;e.preventDefault();if(el===gb3PickHue)gb3HSV.h=(gb3HSV.h+360+delta*3)%360;
   else if(e.shiftKey)gb3HSV.v=Math.max(0,Math.min(1,gb3HSV.v+delta*.025));
   else gb3HSV.s=Math.max(0,Math.min(1,gb3HSV.s+delta*.025));
   gb3PickerRender();setMaterial('solid');
  });
 }
 if(gb3PickHex){gb3PickHex.addEventListener('change',e=>{
   let val=e.target.value.trim();if(!val.startsWith('#'))val='#'+val;
   if(/^#[0-9a-f]{6}$/i.test(val))gb3SetPickerHex(val,true);else gb3PickerRender();
  });}
}
gb3SetPickerHex(state.color);

let gb3DualOn=false; // Set to the saved/default preference when creating mobile controls.
let mobileTouchMode='look';
function renderTouchModes(){root.querySelectorAll('[data-touch-mode]').forEach(b=>{const active=b.dataset.touchMode===mobileTouchMode;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active))})}
function setTouchMode(mode){mobileTouchMode=gb3DualOn?'paint':(mode==='paint'?'paint':'look');if(!isTouchDevice){selectTool(mode==='look'?'look':'spray');}if(mobileTouchMode==='paint'&&state.tool==='look')selectTool('spray');renderTouchModes();$('hint').textContent=mobileTouchMode==='look'?'ONE FINGER: LOOK · TWO: ZOOM':'ONE FINGER: PAINT · TWO: ZOOM'}
function selectTool(v){if(v!=='spray')gb3SetSprayPainting(false);state.tool=v;root.querySelectorAll('[data-tool]').forEach(b=>b.classList.toggle('active',b.dataset.tool===v));root.querySelectorAll('[data-mobile-tool]').forEach(b=>b.classList.toggle('is-active',b.dataset.mobileTool===v));$('hint').textContent=v==='look'?'DRAG TO LOOK · WASD TO WALK':'DRAG TO PAINT · WASD TO WALK · RIGHT DRAG TO LOOK';if(isTouchDevice){mobileTouchMode=gb3DualOn?'paint':(v==='look'?'look':'paint');renderTouchModes()}}
root.querySelectorAll('[data-tool]').forEach(b=>b.addEventListener('click',()=>selectTool(b.dataset.tool)));
{
  root.classList.add('gb3-unified');
  const ui=document.createElement('div');ui.className='gb3-mobile-ui';
  ui.innerHTML=`<nav class="gb3-compact-toolbar" aria-label="Graffiti painting toolbar"><button type="button" data-mobile-tool="spray" title="Spray pattern, size, flare, dust, opacity and thickness" aria-label="Spray settings" data-tooltip="Spray settings" class="is-active"><img class="gb3-tool-icon" src="${root.dataset.gb3SprayIcon}" alt=""><small>SPRAY</small></button><button type="button" data-mobile-tool="marker" title="Choose Markers — hold for settings" aria-label="Choose Markers — hold for settings" data-tooltip="Choose Markers"><img class="gb3-tool-icon" src="${root.dataset.gb3MarkerIcon}" alt=""><small>MARKERS</small></button><button type="button" data-mobile-tool="wash" title="Choose Eraser — hold for undo and clear" aria-label="Choose Eraser — hold for options" data-tooltip="Choose Eraser">⌁<small>ERASE</small></button><button type="button" data-mobile-panel="tools" aria-expanded="false" title="Choose Colors — tap to open picker and sliders" aria-label="Choose Colors — tap to open picker and sliders" data-tooltip="Choose Colors" aria-pressed="true" class="is-active gb3-solid-selected"><span class="gb3-mobile-color-dot" data-gb3-mobile-color-dot aria-hidden="true"></span><small>COLORS</small></button><button type="button" data-mobile-panel="session" aria-expanded="false" title="Photos and saved painting" aria-label="Photos and saved painting">▤<small>WORK</small></button></nav><div class="gb3-mobile-erase-menu" data-gb3-erase-menu hidden role="group" aria-label="Eraser actions"><button type="button" data-gb3-erase-action="undo" title="Undo last stroke">↶ UNDO</button><button type="button" data-gb3-erase-action="clear" title="Clear the train">✕ CLEAR TRAIN</button><button type="button" data-gb3-erase-action="wash" title="Choose eraser">⌁ ERASER</button></div><div class="gb3-touch-mode-buttons" role="group" aria-label="Touch interaction mode"><button type="button" data-gb3-roof-toggle title="Switch between ground and roof height" aria-label="Switch between ground and roof height">↑</button><button type="button" data-touch-mode="look" aria-pressed="true"><span aria-hidden="true">👁</span> LOOK</button><button type="button" data-touch-mode="paint" aria-pressed="false"><span aria-hidden="true">🎨</span> PAINT</button></div><div class="gb3-mobile-zoom-indicator" data-gb3-touch-zoom>PINCH TO ZOOM</div>`;
  root.appendChild(ui);
  // Keep the joystick inside the same overlay/stacking context in inline and fullscreen views.
  if(isTouchDevice){
    const movePad=$('touchpad');
    ui.appendChild(movePad);
    for(const [direction,glyph] of [['left','◀'],['right','▶']]){
      const arrow=document.createElement('span');
      arrow.className='gb3-stick-arrow gb3-stick-arrow--'+direction;
      arrow.textContent=glyph;arrow.setAttribute('aria-hidden','true');
      movePad.appendChild(arrow);
    }
  }
  // Marker presets use exactly the same squeezer icon for all four options.
  // Keep their selection distinct from the color/paint-type picker.
  const markerTitle=document.createElement('div');
  markerTitle.className='gb3-markers-title';
  markerTitle.innerHTML='<span class="eyebrow">CHOOSE MARKERS</span><output data-gb3-marker-name>MARKER 1</output>';
  const markerOptions=document.createElement('div');
  markerOptions.className='gb3-marker-options';
  markerOptions.setAttribute('role','group');
  markerOptions.setAttribute('aria-label','Choose marker type');
  for(let markerNo=1;markerNo<=4;markerNo++){
    const b=document.createElement('button');b.type='button';b.className='gb3-marker-option';
    b.dataset.markerVariant=String(markerNo);b.setAttribute('aria-pressed',String(markerNo===state.markerVariant));
    b.title='Choose Marker '+markerNo;
    const img=document.createElement('img');img.src=root.dataset.gb3MarkerIcon||'';
    img.alt='';img.setAttribute('aria-hidden','true');
    const caption=document.createElement('small');caption.textContent='MARKER '+markerNo;
    b.append(img,caption);markerOptions.append(b);
  }
  const capHeading=root.querySelector('.hud-left > .gb3-cap-title');
  if(capHeading)capHeading.before(markerTitle,markerOptions);
  const eraseMenu=ui.querySelector('[data-gb3-erase-menu]');
  const mobileSubpanels=['gb3-subpanel-caps','gb3-subpanel-spray','gb3-subpanel-colors','gb3-subpanel-markers'];
  function closeMobileMenus(){
    root.classList.remove('gb3-panel-tools','gb3-panel-session',...mobileSubpanels);
    eraseMenu.hidden=true;
    ui.querySelectorAll('[data-mobile-panel]').forEach(b=>b.setAttribute('aria-expanded','false'));
  }
  function openMobileTools(which){
    const name='gb3-subpanel-'+which;
    const already=root.classList.contains('gb3-panel-tools')&&root.classList.contains(name);
    closeMobileMenus();
    if(!already){root.classList.add('gb3-panel-tools',name);}
  }
  function openEraseMenu(){
    const wasOpen=!eraseMenu.hidden;
    closeMobileMenus();eraseMenu.hidden=wasOpen;
  }
  function selectMarkerVariant(v){
    state.markerVariant=v;
    markerOptions.querySelectorAll('[data-marker-variant]').forEach(b=>{
      const picked=Number(b.dataset.markerVariant)===v;
      b.classList.toggle('selected',picked);b.setAttribute('aria-pressed',String(picked));
    });
    const name=markerTitle.querySelector('[data-gb3-marker-name]');
    if(name)name.textContent='MARKER '+v;
    selectTool('marker');closeMobileMenus();
  }
  markerOptions.querySelectorAll('[data-marker-variant]').forEach(b=>{
    b.classList.toggle('selected',Number(b.dataset.markerVariant)===state.markerVariant);
    b.addEventListener('click',()=>selectMarkerVariant(Number(b.dataset.markerVariant)));
  });
  // A short tap selects the tool; holding opens its dedicated chooser.
  gb3MobileLongPress=button=>{
    if(button.dataset.mobileTool==='spray'){selectTool('spray');openMobileTools('spray');return true;}
    if(button.dataset.mobileTool==='marker'){selectTool('marker');openMobileTools('markers');return true;}
    if(button.dataset.mobileTool==='wash'){openEraseMenu();return true;}
    if(button.dataset.mobilePanel==='tools'){openMobileTools('colors');return true;}
    return false;
  };
  // Desktop mouse or pen long-hold opens the very same toolbar submenus as mobile.
  // A capture listener suppresses the synthetic release-click after an activated hold.
  if(!isTouchDevice){
   let holdTimer=null,holdButton=null,held=false,startX=0,startY=0;
   const toolbar=ui.querySelector('.gb3-compact-toolbar');
   toolbar.addEventListener('pointerdown',e=>{
    if(e.button!==0||!e.target.closest('button'))return;
    holdButton=e.target.closest('button');held=false;startX=e.clientX;startY=e.clientY;
    clearTimeout(holdTimer);
    holdTimer=setTimeout(()=>{holdTimer=null;if(holdButton){held=gb3MobileLongPress(holdButton);}},520);
   });
   toolbar.addEventListener('pointermove',e=>{
    if(holdButton&&Math.hypot(e.clientX-startX,e.clientY-startY)>10){clearTimeout(holdTimer);holdTimer=null;}
   });
   const end=()=>{clearTimeout(holdTimer);holdTimer=null;holdButton=null;};
   toolbar.addEventListener('pointerup',end);toolbar.addEventListener('pointercancel',end);
   toolbar.addEventListener('click',e=>{
    if(held){e.preventDefault();e.stopImmediatePropagation();held=false;}
   },true);
   // Right-click on tools offers quick access without affecting the 3D canvas.
   toolbar.addEventListener('contextmenu',e=>{
    const b=e.target.closest('button');if(!b)return;
    if(gb3MobileLongPress(b)){e.preventDefault();e.stopPropagation();}
   });
  }
  ui.querySelectorAll('[data-touch-mode]').forEach(b=>b.addEventListener('click',()=>{setTouchMode(b.dataset.touchMode);closeMobileMenus()}));
  ui.querySelectorAll('[data-mobile-tool]').forEach(b=>b.addEventListener('click',()=>{
    const tool=b.dataset.mobileTool;
    if(!isTouchDevice && tool==='marker'){
      // PC: choose a preset BEFORE switching tool; never open the color picker.
      openMobileTools('markers');return;
    }
    if(!isTouchDevice && tool==='wash'){
      // PC: ERASE has the same Undo / Clear Train / Eraser menu as mobile.
      openEraseMenu();return;
    }
    selectTool(tool);
    if(tool==='spray')openMobileTools('spray');else closeMobileMenus();
  }));
  ui.querySelectorAll('[data-mobile-panel]').forEach(b=>b.addEventListener('click',()=>{
    if(b.dataset.mobilePanel==='tools'){
      // One tap both selects solid paint and TOGGLES the color picker.
      // No long press is required; a second tap closes the panel.
      setMaterial('solid');
      if(state.tool==='wash'||state.tool==='look')selectTool('spray');
      openMobileTools('colors');
    }else{
      const active=root.classList.contains('gb3-panel-session');
      closeMobileMenus();if(!active){root.classList.add('gb3-panel-session');b.setAttribute('aria-expanded','true');}
    }
  }));
  ui.querySelectorAll('[data-gb3-erase-action]').forEach(b=>b.addEventListener('click',()=>{
    const action=b.dataset.gb3EraseAction;
    closeMobileMenus();
    if(action==='undo')$('undo').click();
    else if(action==='clear')$('clear').click();
    else selectTool('wash');
  }));
  // Dismiss popovers when clicking outside their controls, without breaking painting.
  view.addEventListener('pointerdown',()=>{if(root.classList.contains('gb3-panel-tools')||!eraseMenu.hidden)closeMobileMenus()});
  ui.querySelector('[data-gb3-roof-toggle]').addEventListener('click',e=>{const goUp=cam.y<4.1;cam.y=goUp?5.1:gb3SprayConfig.cameraHeight;cam.pitch=goUp?-.22:-.025;e.currentTarget.textContent=goUp?'↓':'↑';e.currentTarget.setAttribute('aria-label',goUp?'Return to ground height':'Switch to roof height');toast(goUp?'Roof view: pinch and spray':'Ground view')});
  renderTouchModes();
  const helpGrid=$('helpModal').querySelector('.help-grid');
  if(isTouchDevice&&helpGrid)helpGrid.innerHTML='<div><b>🕹 MOVE</b><small>Hold and drag to walk</small></div><div><b>👁 LOOK</b><small>One finger rotates camera</small></div><div><b>🎨 PAINT</b><small>One finger sprays train</small></div><div><b>🤏 TWO FINGERS</b><small>Pinch out to zoom in</small></div>';
  const para=$('helpModal').querySelector('.modal-panel>p');if(isTouchDevice&&para)para.textContent='Every wall has a story. GBattle 3D gives writers a virtual yard to explore, experiment with color and build their own style. Use MOVE to walk, LOOK to explore, PAINT to spray, and pinch to zoom.';
}
function setMaterial(v){
 state.mat=v;
 root.querySelectorAll('[data-material]').forEach(b=>b.classList.toggle('selected',b.dataset.material===v));
 const colorBtn=root.querySelector('[data-mobile-panel="tools"]');
 if(colorBtn){
   const solid=v==='solid';
   colorBtn.classList.toggle('is-active',solid);
   colorBtn.classList.toggle('gb3-solid-selected',solid);
   colorBtn.setAttribute('aria-pressed',String(solid));
   const dot=colorBtn.querySelector('[data-gb3-mobile-color-dot]');
   if(dot)dot.style.backgroundColor=state.color;
 }
}
root.querySelectorAll('[data-material]').forEach(b=>b.addEventListener('click',()=>setMaterial(b.dataset.material)));
setMaterial(state.mat);gb3PickerRender();
for(const [name,key,suffix,convert] of [['size','size',' cm',Number],['opacity','opacity','%',v=>Number(v)/100],['dust','dust','%',v=>Number(v)/100]]){$(name).addEventListener('input',e=>{state[key]=convert(e.target.value);$(name+'Value').textContent=e.target.value+suffix})}
// Flare is a real user-adjustable spray control; reuse existing setting styling.
{
 const dustSetting=$('dust')?.closest('label');
 if(dustSetting&&!root.querySelector('[data-gb3="flare"]')){
   const label=document.createElement('label');label.className='setting gb3-setting-dust gb3-setting-flare';
   label.append(document.createTextNode('FLARE '));
   const value=document.createElement('output');value.textContent=Math.round(state.flare*100)+'%';
   const slider=document.createElement('input');slider.type='range';slider.min='0';slider.max='100';slider.step='5';slider.value=String(Math.round(state.flare*100));
   slider.dataset.gb3='flare';slider.setAttribute('aria-label','Spray speed flare strength');
   slider.addEventListener('input',()=>{state.flare=Number(slider.value)/100;value.textContent=slider.value+'%';});
   label.append(value,slider);dustSetting.insertAdjacentElement('afterend',label);
 }
 // Separate spray DROPLET SIZE from cap SIZE, DUST amount, and FLARE.
 // The default is finer than the old spray. The right end recreates coarse droplets.
 if(dustSetting&&!root.querySelector('[data-gb3="sprayThickness"]')){
   const label=document.createElement('label');label.className='setting gb3-setting-dust gb3-setting-spray-thickness';
   label.title='0% = very fine mist; 100% = thick original droplets. Does not change cap diameter.';
   label.append(document.createTextNode('SPRAY THICKNESS '));
   const value=document.createElement('output');value.textContent=Math.round(state.sprayThickness*100)+'%';
   const slider=document.createElement('input');slider.type='range';slider.min='0';slider.max='100';slider.step='5';
   slider.value=String(Math.round(state.sprayThickness*100));slider.dataset.gb3='sprayThickness';
   slider.setAttribute('aria-label','Spray droplet thickness. Zero is very fine, one hundred is coarse');
   slider.title='FINE mist ← 0%   ·   100% → COARSE droplets';
   slider.addEventListener('input',()=>{state.sprayThickness=Number(slider.value)/100;value.textContent=slider.value+'%';});
   label.append(value,slider);dustSetting.insertAdjacentElement('afterend',label);
 }
}
{
 const capList=$('caps');
 const selectors=['.gb3-setting-size','.gb3-setting-flare',
   '.gb3-setting-dust:not(.gb3-setting-flare):not(.gb3-setting-spray-thickness)',
   '.gb3-setting-opacity','.gb3-setting-spray-thickness','.gb3-setting-drips'];
 let anchor=capList;
 if(anchor)for(const sel of selectors){
  const element=root.querySelector('.hud-left > '+sel);
  if(!element)continue;anchor.insertAdjacentElement('afterend',element);anchor=element;
 }
}
$('drips').onchange=e=>{state.drips=e.target.checked;if(!state.drips){wetPools.length=0;activeDrips.length=0;}};
// v2.3 — Brush masks and previews come from the owner's P20 server.
// Important: browser-delivered PNGs remain inspectable; they are NOT secret.
let sprayStamp=null,stampKey='';
const gb3CapNames=["ap-micro", "astro-f3", "fbs", "la-outline", "lego-10", "ny-fat", "ny-outline-10", "pink-dot", "rd-cali", "red-b-fat", "rusto-fat", "sky-dot-fat"];
state.cap='ny-fat';
const gb3CapImages=new Map();
const gb3CapBase=(root.dataset.gb3CapBase||'https://gbattle.sweink.com/3d/caps/').replace(/\/?$/,'/');
const gb3CapChooser=$('caps');
const gb3CapTitle=root.querySelector('.gb3-cap-title .eyebrow');if(gb3CapTitle)gb3CapTitle.textContent='SPRAY PATTERN';
function gb3RefreshCapStatus(){
 const label=$('capName');if(!label)return;
 label.textContent=state.cap.replace(/-/g,' ').toUpperCase()+(gb3CapImages.has(state.cap)?'':' · DEFAULT');
 label.title=gb3CapImages.has(state.cap)?'Original P20 spray mask loaded':'Using default spray while P20 brush loads or is unavailable';
}
function gb3SelectCap(name){
 if(!gb3CapNames.includes(name))return;state.cap=name;sprayStamp=null;stampKey='';
 if(gb3CapChooser)gb3CapChooser.querySelectorAll('[data-cap]').forEach(b=>{const active=b.dataset.cap===name;b.classList.toggle('selected',active);b.setAttribute('aria-pressed',String(active))});
 gb3RefreshCapStatus();
}
if(gb3CapChooser){
 for(const name of gb3CapNames){
  const btn=document.createElement('button');btn.type='button';btn.className='gb3-cap-option';btn.dataset.cap=name;btn.title=name.replace(/-/g,' ').toUpperCase();btn.setAttribute('aria-label','Spray cap '+btn.title);btn.setAttribute('aria-pressed','false');
  const img=document.createElement('img');img.alt='';img.loading='lazy';img.crossOrigin='anonymous';
  img.onerror=()=>{img.hidden=true;img.style.display='none';btn.classList.add('gb3-cap-unavailable');};
  img.src=gb3CapBase+'thumb-'+name+'.png';
  const small=document.createElement('small');small.textContent=name.replace(/-/g,' ');btn.append(img,small);btn.onclick=()=>gb3SelectCap(name);gb3CapChooser.append(btn);
  const url=gb3CapBase+name+'.png';
  const brush=new Image();brush.crossOrigin='anonymous';
  brush.onload=()=>{gb3CapImages.set(name,brush);btn.classList.remove('gb3-cap-unavailable');if(state.cap===name){sprayStamp=null;stampKey='';gb3RefreshCapStatus()}};
  brush.onerror=()=>{console.warn('GBattle cap unavailable, using default stamp:',name);if(state.cap===name)gb3RefreshCapStatus()};
  brush.src=url;
 }
 gb3SelectCap(state.cap);
}
const swatches={chrome:['#212a33','#939ca4','#f4f8fa','#5a656e','#eff5f8','#2b343e'],gold:['#392004','#a86e09','#fff4ac','#9a5c05','#f9d44d','#543209'],copper:['#481f17','#b55f32','#f8c697','#a24a27','#f0a16b','#5c291c'],tar:['#06080a','#111417','#373b3d','#0d1115','#202426','#050708']};
// Spray Engine R2: visible accumulated wetness + bounded gravity rivers.
// Keep the original canvas paint system, drip toggle, save snapshots and washer.
// LONG strokes have strongly varied lengths, not width-dependent short tails.
const wetPools=[],activeDrips=[],MAX_WET_POOLS=isTouchDevice?125:170,MAX_ACTIVE_DRIPS=isTouchDevice?54:86;
let currentPaintActionId=0,lastWetSample=null,dripLastTick=0,dripTimer=null;
function paintInk(){return state.mat==='gold'?'#d8ac34':state.mat==='chrome'?'#b4c0c9':state.mat==='copper'?'#c77d50':state.mat==='tar'?'#14191d':state.color}
function gb3SurfaceResponse(hit){
 const p=hit.p,name=(p.name||'').toLowerCase(),uvx=hit.u*p.canvas.width,uvy=hit.v*p.canvas.height;
 const roof=p.region==='roof'||name.includes('roof');
 const end=p.region==='end';
 const door=name.includes('door');
 const ribbed=name.includes('rib')||name.includes('side')||name.includes('body')||name.includes('wall');
 const rough=name.includes('concrete')||name.includes('brick')||name.includes('stone');
 // Stable microstructure tied to surface UVs; no frame-to-frame random jitter.
 const rib= ribbed?Math.abs(Math.sin(uvx*.077+Math.sin(uvy*.018)*.3)):0;
 const grain=Math.sin(uvx*1.41+uvy*.38)*Math.cos(uvy*1.23-uvx*.29);
 let adhesion=1,spread=1,scatter=1;
 if(roof){adhesion=.68;spread=1.10;scatter=.88;}
 else if(rough){adhesion=1.16;spread=1.07;scatter=1.72;}
 else if(door){adhesion=.93;spread=.99;scatter=1.02;}
 else if(end){adhesion=.97;scatter=.97;}
 if(ribbed){adhesion*=.77+.23*rib;scatter*=1.08;}
 adhesion*=1+grain*(rough?.21:.06);
 return {adhesion:clamp(adhesion,.42,1.5),spread,scatter,roughness:rough?1:ribbed?.43:.16,roof,door,ribbed,grain};
}
function dropWetness(hit,r,held=false,intensity=1){
 if(!state.drips||state.tool!=='spray'||!hit||!hit.p||hit.p.region==='roof')return;
 const p=hit.p,x=clamp(hit.u*p.canvas.width,0,p.canvas.width),y=clamp(hit.v*p.canvas.height,0,p.canvas.height);
 const now=performance.now(),movement=lastWetSample&&lastWetSample.p===p?Math.hypot(lastWetSample.x-x,lastWetSample.y-y):r*2;
 const slow=held?2.45:1+clamp(1-movement/Math.max(4,r*.85),0,1)*.85;
 const surface=gb3SurfaceResponse(hit),finishWet=state.mat==='tar'?1.30:state.mat==='chrome'?.78:1;
 const amount=(held?.27:.105)*state.opacity*slow*clamp(intensity,.25,1.65)*surface.adhesion*finishWet;
 lastWetSample={p,x,y};
 const near=Math.max(6,Math.min(28,r*.92)),near2=near*near;
 let pool=null;
 for(let i=wetPools.length-1;i>=0;i--){const w=wetPools[i];if(w.p!==p||w.actionId!==currentPaintActionId)continue;
   if((w.x-x)**2+(w.y-y)**2<near2){pool=w;break;}}
 if(pool){const mix=Math.min(.22,amount/(pool.wet+amount));pool.x+=(x-pool.x)*mix;pool.y+=(y-pool.y)*mix;
   pool.wet=Math.min(7,pool.wet+amount);pool.width=Math.max(pool.width,r);pool.touched=now;}
 else if(wetPools.length<MAX_WET_POOLS){wetPools.push({p,x,y,wet:amount,width:r,color:paintInk(),opacity:state.opacity,actionId:currentPaintActionId,touched:now,
   charge:rnd(.0,.35),threshold:rnd(.44,.92),emitted:0,adhesion:surface.adhesion});}
 if(wetPools.length||activeDrips.length)ensureDripTimer();
}
function spawnGravityDrip(w){
 if(activeDrips.length>=MAX_ACTIVE_DRIPS||w.y>=w.p.canvas.height-4)return;
 const r=Math.max(3,w.width),wet=clamp(w.wet/2.7,.13,1.5),room=w.p.canvas.height-w.y-2;
 const thin=Math.random();
 const width=clamp(r*(thin<.54?rnd(.018,.057):thin<.91?rnd(.058,.135):rnd(.14,.25))*(.8+wet*.34),.65,9.3);
 // 15% short, 48% medium, 37% LONG, independent of cap diameter.
 const draw=Math.random();
 const length=draw<.15?rnd(18,62):draw<.63?rnd(66,158):rnd(155,365);
 const lengthBoost=clamp(.74+wet*.36,.76,1.38);
 const y=clamp(w.y+rnd(-r*.13,r*.18),1,w.p.canvas.height-3);
 const x=clamp(w.x+rnd(-r*.44,r*.44),2,w.p.canvas.width-2);
 const maxLength=Math.min(room,length*lengthBoost);
 if(maxLength<9)return;
 // Random 0..4 split events, biased upward by length and fresh wet volume.
 const probability=clamp(.06+wet*.24+maxLength/420,.08,.95);
 const forkRoll=Math.random();
 const forkBudget=forkRoll>probability?0:forkRoll<probability*.25?3+(Math.random()<.4?1:0):forkRoll<probability*.60?2:1;
 const d={p:w.p,x,y,startY:y,width,length:maxLength,speed:rnd(33,100),phase:rnd(0,TAU),bend:rnd(-.45,.45),
   color:w.color,opacity:clamp(w.opacity*.8,.12,1),actionId:w.actionId,volume:wet,depth:0,
   forkBudget,splitAt:forkBudget?rnd(.16,.48):0,splitDone:false,fade:rnd(.78,1.23)};
 activeDrips.push(d);
}
function ensureDripTimer(){if(!dripTimer){dripLastTick=performance.now();dripTimer=setTimeout(stepWetDrips,65);}}
function splitWetDrip(d,progress){
 if(!d.splitAt||d.splitDone||progress<d.splitAt||d.depth>=3||activeDrips.length>=MAX_ACTIVE_DRIPS)return;
 d.splitDone=true;
 const room=Math.min(d.p.canvas.height-2-d.y,d.length*(1-progress));
 if(room<14||d.width<.85||d.volume<.105||d.forkBudget<=0)return;
 const originalVolume=d.volume,originalWidth=d.width,sign=Math.random()<.5?-1:1;
 // Usually Y; occasionally two daughter branches. Wet parent retains paint.
 const available=Math.min(MAX_ACTIVE_DRIPS-activeDrips.length,d.volume>.52&&d.width>2.2&&Math.random()<.22?2:1);
 const childShares=[];
 let shareLeft=.70;
 for(let i=0;i<available;i++){
   const fraction=Math.min(shareLeft*.76,rnd(.19,.38));shareLeft-=fraction;childShares.push(fraction);
 }
 const sum=childShares.reduce((a,b)=>a+b,0);
 d.volume=originalVolume*(1-sum);d.width=Math.max(.45,originalWidth*Math.sqrt(1-sum));
 d.bend-=sign*rnd(.18,.55);
 d.forkBudget=Math.max(0,d.forkBudget-1-available);
 d.splitAt=d.forkBudget>0?rnd(Math.min(.96,progress+.10),Math.min(.99,progress+.28)):0;
 d.splitDone=!d.splitAt;
 for(let i=0;i<childShares.length;i++){
   const share=childShares[i],volume=originalVolume*share,depth=d.depth+1;
   const childLen=Math.min(d.p.canvas.height-d.y-2,Math.max(12,room*rnd(.46,1.45)));
   const forkChance=clamp(.03+volume*.42+childLen/560,0,.74);
   const forkBudget=depth<3&&Math.random()<forkChance?(Math.random()<.24?2:1):0;
   activeDrips.push({...d,x:d.x,y:d.y,startY:d.y,volume,width:Math.max(.55,originalWidth*Math.sqrt(share)),
     length:childLen,speed:d.speed*rnd(.74,1.10),bend:d.bend+sign*(i===0?1:-1)*rnd(1.25,2.65),
     phase:rnd(0,TAU),depth,forkBudget,splitDone:!forkBudget,splitAt:forkBudget?rnd(.19,.62):0,
     fade:rnd(.7,1.10)});
 }
}
function stepWetDrips(){
 dripTimer=null;
 if(!state.drips){wetPools.length=0;activeDrips.length=0;return;}
 const now=performance.now(),dt=clamp((now-dripLastTick)/1000,.01,.13);dripLastTick=now;
 for(let i=wetPools.length-1;i>=0;i--){const w=wetPools[i],age=(now-w.touched)/1000;
   w.wet=Math.max(0,w.wet-dt*(.075+age*.052));
   w.charge+=dt*(.36+w.wet*.74);
   // Wide wet lines can emit MANY independent streams at distinct x positions.
   if(w.wet>.27&&w.charge>=w.threshold&&activeDrips.length<MAX_ACTIVE_DRIPS){
     w.charge=0;const available=w.wet;
     w.wet=Math.max(0,w.wet-rnd(.22,.46));w.emitted++;
     spawnGravityDrip({...w,wet:available});w.threshold=rnd(.38,.98);
   }
   if(w.wet<.045||age>12)wetPools.splice(i,1);
 }
 // Snapshot count prevents new forks from being stepped until the next tick.
 for(let i=activeDrips.length-1;i>=0;i--){
   const d=activeDrips[i],p=d.p,remaining=d.length-(d.y-d.startY);
   const dy=Math.min(remaining,(d.speed+=47*dt)*dt);
   if(!(dy>0)||d.volume<.035){activeDrips.splice(i,1);continue;}
   const oldX=d.x,oldY=d.y,progress=clamp((oldY-d.startY)/Math.max(1,d.length),0,1);
   const wobble=Math.sin(progress*13+d.phase)*Math.min(.24,d.width*.11)*dt*14+d.bend*dt*7.0;
   // Branches open into a Y, then gravity gradually straightens the tails.
   d.bend*=Math.max(.65,1-dt*(d.depth?1.05:.36));
   d.x=clamp(d.x+wobble,1,p.canvas.width-1);d.y=Math.min(p.canvas.height-1,d.y+dy);
   const tapered=clamp(d.width*Math.pow(Math.max(.02,1-progress),.44)*d.fade,.42,10.2);
   const ctx=p.ctx;ctx.save();ctx.globalAlpha=d.opacity;ctx.strokeStyle=d.color;ctx.lineCap='round';ctx.lineJoin='round';ctx.lineWidth=tapered;
   ctx.beginPath();ctx.moveTo(oldX,oldY);ctx.quadraticCurveTo((oldX+d.x)/2,(oldY+d.y)/2,d.x,d.y);ctx.stroke();
   if(progress>.80||remaining<=dy+1){ctx.beginPath();ctx.ellipse(d.x,d.y,Math.max(.45,tapered*.53),Math.max(.5,tapered*.66),0,0,TAU);ctx.fillStyle=d.color;ctx.fill();}
   ctx.restore();dirty.add(p);
   splitWetDrip(d,progress);
   if(d.y>=d.startY+d.length-1||d.y>=p.canvas.height-2)activeDrips.splice(i,1);
 }
 if(wetPools.length||activeDrips.length)dripTimer=setTimeout(stepWetDrips,65);
 else if(!dragging)saveLater();
}
function removeWetAt(p,x,y,r){
 for(let i=wetPools.length-1;i>=0;i--){const w=wetPools[i];if(w.p===p&&Math.hypot(w.x-x,w.y-y)<r*1.65)wetPools.splice(i,1);}
 for(let i=activeDrips.length-1;i>=0;i--){const d=activeDrips[i];if(d.p===p&&Math.hypot(d.x-x,d.y-y)<r*1.65)activeDrips.splice(i,1);}
}
function makeStamp(){let id=[state.mat,state.color,state.tool,state.cap,gb3CapImages.has(state.cap)].join('|');if(id===stampKey&&sprayStamp)return sprayStamp;stampKey=id;let c=document.createElement('canvas');c.width=c.height=128;let ctx=c.getContext('2d');
 if(state.mat==='solid'){ctx.fillStyle=state.color;ctx.fillRect(0,0,128,128)}else{let g=ctx.createLinearGradient(0,0,128,0);let stops=swatches[state.mat];stops.forEach((color,i)=>g.addColorStop(i/(stops.length-1),color));ctx.fillStyle=g;ctx.fillRect(0,0,128,128)}
 ctx.globalCompositeOperation='destination-in';const brush=state.tool==='spray'?gb3CapImages.get(state.cap):null;if(brush){ctx.drawImage(brush,0,0,128,128)}else{let r=ctx.createRadialGradient(64,64,1,64,64,64);r.addColorStop(0,'rgba(255,255,255,.95)');r.addColorStop(.55,'rgba(255,255,255,.80)');r.addColorStop(.85,'rgba(255,255,255,.2)');r.addColorStop(1,'rgba(255,255,255,0)');ctx.fillStyle=r;ctx.fillRect(0,0,128,128)}sprayStamp=c;return c}
// Full spray deposition: physical stand-off, incidence, speed/flare, and texture.
function gb3SprayPhysics(hit,speed=0){
 const cfg=gb3SprayConfig;
 const distance=Number.isFinite(hit.distance)?hit.distance:1.2;
 // Physical cone: close spray remains close to the selected cap diameter.
 // Widen only over the final 2.3m of the deliberately SHORT 3.2m reach.
 const linearStandOff=clamp((distance-cfg.spreadStart)/(cfg.spreadFull-cfg.spreadStart),0,1);
 const standOff=linearStandOff*linearStandOff*(3-2*linearStandOff);
 // A centred ray and an edge ray do NOT paint the same projected footprint.
 // Use real ray/eye divergence, surface incidence and the current camera FOV;
 // never use arbitrary pointer jitter or force widening on markers/erasers.
 const centralRay=forward();
 const divergence=Math.acos(clamp(dot(unit(hit.ray||centralRay),centralRay),-1,1));
 const edgeAngle=Math.atan(Math.tan(fov/2)*Math.hypot(1,(width/Math.max(1,height))));
 const edge=clamp(divergence/Math.max(.001,edgeAngle),0,1);
 const viewWiden=1+cfg.offAxisWiden*Math.pow(edge,cfg.offAxisPower);
 const distanceSpread=clamp((cfg.spreadNear+(cfg.spreadFar-cfg.spreadNear)*standOff)*viewWiden,
   cfg.spreadNear,cfg.maxViewSpread);
 const ray=hit.ray||unit([hit.world[0]+trainMotion.x-cam.x,hit.world[1]-cam.y,hit.world[2]-cam.z]);
 const normal=hit.normal||[0,0,1];
 const incidence=clamp(Math.abs(dot(unit(normal),unit(ray))),.03,1);
 const graze=clamp((1-incidence)*1.12,0,.97);
 const surface=gb3SurfaceResponse(hit);
 const p=hit.p,nominal=Math.max(1.6,state.size/100/p.len*p.canvas.width/2);
 // Dead zone + smooth ramp. Small drag events no longer crush the line.
 const moving=clamp((speed-cfg.speedSoftStart)/(cfg.speedFull-cfg.speedSoftStart),0,1);
 const fast=moving*moving*(3-2*moving);
 const flare=clamp(state.flare,0,1);
 const pinch=1-fast*cfg.speedPinch*flare;
 const radius=clamp(nominal*distanceSpread*pinch*surface.spread,1.2,nominal*cfg.maxViewSpread*1.14);
 const density=clamp((1-fast*cfg.speedDensityDrop)*Math.pow(1/distanceSpread,.68)*(1-graze*.55)*surface.adhesion,.12,1.20);
 const elongate=1+graze*1.65;
 const finish=state.mat==='tar'?1.12:state.mat==='chrome'?.84:1;
 // The footprint elongates along the ray projected onto the actual surface.
 // Mouse-stroke movement determines speed only; it must not rotate the spray cone.
 const viewAngle=Number.isFinite(hit.viewAngle)?hit.viewAngle:0;
 return {radius,density:density*finish,graze,fast,elongate,standOff,incidence,surface,viewAngle};
}
function gb3SprayParticles(c,px,py,r,phys,angle){
 // SPRAY THICKNESS: 0 = atomized mist; 1 = the original coarse paint drops.
 // This does NOT resize the cap footprint and does not alter the wet-drip system.
 const thickness=clamp(state.sprayThickness??1,0,1),fine=1-thickness;
 const dust=clamp(state.dust,0,1),spread=r*(1.75+phys.standOff*.72+phys.graze);
 const scatter=phys.surface.scatter,atomSize=.27+.73*thickness;
 const mobileBudget=isTouchDevice?72:104;
 // Core atomization is present even with zero overspray. More (smaller) grains
 // for a fine mist; the coarsest setting matches the old outer-droplet pattern.
 const coreN=clamp(Math.round(fine*(9+18*scatter)),0,isTouchDevice?22:32);
 const edgeN=dust>0?clamp(Math.round((9+dust*32)*scatter*(.62+phys.standOff*.5)*(1+fine*.60)),0,mobileBudget-coreN):0;
 const ink=paintInk();c.fillStyle=ink;
 for(let i=0;i<coreN;i++){
   const theta=rnd(0,TAU),dist=r*Math.sqrt(Math.random())*.90;
   const along=Math.cos(theta)*dist,across=Math.sin(theta)*dist;
   const sz=clamp(rnd(.48,1.10)*atomSize,.16,1.2);
   c.globalAlpha=clamp(state.opacity*rnd(.09,.22)*phys.density,.018,.23);
   c.fillRect(px+along*phys.elongate,py+across,sz,sz);
 }
 for(let i=0;i<edgeN;i++){
   const t=rnd(0,TAU),dist=r*Math.sqrt(rnd(.4,2.5+phys.standOff)),jitter=rnd(.7,1.32);
   const dx=Math.cos(t)*dist*jitter,dy=Math.sin(t)*dist*jitter;
   const along=dx*Math.cos(angle)-dy*Math.sin(angle),across=dx*Math.sin(angle)+dy*Math.cos(angle);
   c.globalAlpha=clamp(state.opacity*(.09+.21*Math.random())*phys.density*dust,.009,.37);
   const sz=clamp(rnd(.45,1.65)*atomSize*(1+phys.surface.roughness*.34),.15,2.35);
   c.fillRect(px+along*phys.elongate,py+across,sz,sz);
 }
 // Heavy wet splatter is a separate physical behavior: it still appears on
 // slow passes, but droplets are finer when the thickness slider is low.
 if(phys.fast<.46&&phys.standOff<.64&&dust>.18&&Math.random()<.58){
   const count=clamp(2+Math.floor(Math.random()*5)+Math.floor(fine*2),0,8);
   for(let i=0;i<count;i++){
     const t=rnd(0,TAU),d=rnd(r*.90,spread);
     c.globalAlpha=state.opacity*rnd(.14,.36)*phys.density;
     c.beginPath();c.arc(px+Math.cos(t)*d,py+Math.sin(t)*d,rnd(.45,2.1)*atomSize,0,TAU);c.fill();
   }
 }
}
function gb3WasherStreak(c,px,py,r){
 // Preserve the original washer but pull random erased rivulets down the surface.
 const count=3+Math.floor(Math.random()*3);
 c.strokeStyle='#000';c.lineCap='round';
 for(let i=0;i<count;i++){
   const offset=rnd(-.74,.74)*r,len=r*rnd(.75,2.55);
   c.globalAlpha=clamp(state.opacity*rnd(.32,.74),.15,.95);
   c.lineWidth=Math.max(.5,r*rnd(.035,.15));
   c.beginPath();c.moveTo(px+offset,py+rnd(-.24,.15)*r);
   c.quadraticCurveTo(px+offset+rnd(-.35,.35)*r,py+len*.48,px+offset+rnd(-.45,.45)*r,py+len);c.stroke();
 }
}
function paint(hit,dynamics=null){
 if(!hit)return;
 const p=hit.p,c=p.ctx,px=hit.u*p.canvas.width,py=hit.v*p.canvas.height;
 const markerScale=[.65,.9,1.2,1.55][state.markerVariant-1];
 const spray=state.tool==='spray',wash=state.tool==='wash';
 const phys=spray?gb3SprayPhysics(hit,dynamics?.speed||0):null;
 const diam=state.size/100/p.len*p.canvas.width*(state.tool==='marker'?markerScale:1);
 const r=spray?phys.radius:Math.max(2,diam/2);
 const held=!!dynamics?.held,angle=spray?phys.viewAngle:(dynamics?.angle||0);
 const alpha=state.tool==='marker'?state.opacity:Math.max(.014,state.opacity*(.28+(held?.08:0))*(phys?.density||1));
 c.save();
 if(wash){
   removeWetAt(p,px,py,r);c.globalCompositeOperation='destination-out';
   c.globalAlpha=Math.min(1,state.opacity*.78);c.fillStyle='#000';
   c.beginPath();c.arc(px,py,r*1.18,0,TAU);c.fill();
   gb3WasherStreak(c,px,py,r);
 }else{
   const stamp=makeStamp();c.globalAlpha=alpha;
   if(spray){
     c.save();c.translate(px,py);c.rotate(angle);c.scale(phys.elongate,1-phys.graze*.30);
     // Broad diffuse halo behind the denser cap. More stand-off gives dusty edges.
     if(phys.standOff>.05&&state.dust>.02){
       c.globalAlpha=alpha*state.dust*.21;
       c.drawImage(stamp,-r*2.24,-r*2.24,r*4.48,r*4.48);
     }
     c.globalAlpha=alpha;
     c.drawImage(stamp,-r*1.78,-r*1.78,r*3.56,r*3.56);c.restore();
   }else c.drawImage(stamp,px-r*1.85,py-r*1.85,r*3.7,r*3.7);
   if(spray){
     gb3SprayParticles(c,px,py,r,phys,angle);
     dropWetness(hit,r,held,phys.density);
     if(held){
       // Fresh paint settles into a darker saturated pool with irregular wet rims.
       c.globalAlpha=state.opacity*.095*phys.surface.adhesion;c.strokeStyle=paintInk();
       for(let i=0;i<2;i++){
         c.lineWidth=Math.max(.5,r*rnd(.045,.115));
         c.beginPath();c.ellipse(px+rnd(-.1,.1)*r,py+rnd(-.1,.1)*r,
           r*rnd(.31,.56),r*rnd(.30,.48),rnd(-.15,.15),0,TAU);c.stroke();
       }
     }
     // Metallic finishes have fine glints that use the EXISTING swatch colors.
     if(state.mat!=='solid'&&phys.fast<.85){
       const colors=swatches[state.mat];
       if(colors){for(let i=0;i<3;i++){
         c.globalAlpha=state.opacity*rnd(.14,.32)*phys.density;c.fillStyle=colors[(i+2)%colors.length];
         c.fillRect(px+rnd(-r,r),py+rnd(-r,r),rnd(.5,1.5),rnd(.45,1.4));
       }}
     }
   }
 }
 c.restore();dirty.add(p);
}
let dragging=false,turning=false,lastHit=null,lastX=0,lastY=0,lastPaintMotionAt=0,lastDragSampleAt=0,gb3SmoothedStrokeSpeed=0;
// Stationary spraying builds visible pigment and wets the underlying pool.
setInterval(()=>{
 if(dragging&&state.tool==='spray'&&lastHit&&performance.now()-lastPaintMotionAt>100){
   const hit=hitTest(lastX,lastY);
   if(hit){lastHit=hit;paint(hit,{held:true,speed:0,angle:0});}
   else {lastHit=null;gb3SetSprayPainting(false);}
 }
},83);
const activeTouches=new Map();let activeMousePointer=null,pinchDistance=0,pinchStartFov=fov,ignoreUntilTouchRelease=false;
function touchGap(){const points=[...activeTouches.values()];return points.length<2?0:Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y)}
function displayZoom(){const value=root.querySelector('[data-gb3-touch-zoom]');if(value)value.textContent='ZOOM '+Math.round(defaultFov/fov*100)+'%'}
function stopStroke(){gb3SetSprayPainting(false);gb3SmoothedStrokeSpeed=0;if(dragging){dragging=false;lastHit=null;lastWetSample=null;saveLater()}turning=false}
function beginStroke(h){if(!h)return;gb3SetSprayPainting(state.tool==='spray');let snap=h.p.ctx.getImageData(0,0,h.p.canvas.width,h.p.canvas.height);currentPaintActionId++;lastWetSample=null;gb3SmoothedStrokeSpeed=0;lastPaintMotionAt=lastDragSampleAt=performance.now();undo.push({p:h.p,snap,id:currentPaintActionId});if(undo.length>7)undo.shift();$('undoCount').textContent=undo.length+' / 7';strokes++;$('paintedCount').textContent=strokes+' strokes';$('saveState').textContent='UNSAVED'}
function dragStroke(hit){
 gb3SetSprayPainting(!!hit&&state.tool==='spray'&&dragging);
 if(!hit){lastHit=null;return;}
 const now=performance.now(),elapsed=clamp((now-lastDragSampleAt)/1000,.016,.20);
 lastDragSampleAt=now;lastPaintMotionAt=now;
 if(!lastHit||lastHit.p!==hit.p){paint(hit,{speed:0,angle:0});lastHit=hit;return}
 const dx=(hit.u-lastHit.u)*hit.p.canvas.width,dy=(hit.v-lastHit.v)*hit.p.canvas.height;
 const dist=Math.hypot(dx,dy),instantSpeed=dist/elapsed,angle=Math.atan2(dy,dx);
 // Low-pass speed: small event jitter cannot trigger instant full-flare strokes.
 // A sustained fast movement still responds promptly (0.11 second time constant).
 const mix=1-Math.exp(-elapsed/.11);
 gb3SmoothedStrokeSpeed+=mix*(instantSpeed-gb3SmoothedStrokeSpeed);
 const speed=gb3SmoothedStrokeSpeed;
 const step=Math.max(2,state.size/100/hit.p.len*hit.p.canvas.width*.30);
 // Particle flux is time-based, not fixed per dragged pixel. Fast flicks thin out.
 const timeBudget=Math.max(1,Math.ceil(elapsed*(isTouchDevice?100:125)));
 const count=state.tool==='spray'?clamp(Math.min(Math.ceil(dist/step),timeBudget),1,56):clamp(Math.ceil(dist/step),1,70);
 for(let i=1;i<=count;i++){
   const a=i/count;
   paint({...hit,u:lastHit.u+(hit.u-lastHit.u)*a,v:lastHit.v+(hit.v-lastHit.v)*a},{speed,angle});
 }
 lastHit=hit;
}
function pointerCoord(e){let r=view.getBoundingClientRect();return [e.clientX-r.left,e.clientY-r.top]}
// Touch controls: one finger follows an explicit LOOK/PAINT mode;
// two fingers always pinch to zoom and never leave stray paint strokes.
view.addEventListener('pointerdown',e=>{
  if(e.pointerType==='touch'){
    e.preventDefault();const [x,y]=pointerCoord(e);activeTouches.set(e.pointerId,{x,y});view.setPointerCapture(e.pointerId);
    if(activeTouches.size>=2){stopStroke();ignoreUntilTouchRelease=true;pinchDistance=touchGap();pinchStartFov=fov;displayZoom();return}
    if(ignoreUntilTouchRelease)return;
    lastX=x;lastY=y;
    if(!gb3DualOn&&mobileTouchMode==='look'){turning=true;return}
    const h=hitTest(x,y);if(!h){toast('Walk closer to the train to paint · spray reach 3.2 m');return}
    beginStroke(h);dragging=true;lastHit=null;dragStroke(h);return;
  }
  if(e.button!==0&&e.button!==2)return;
  const [x,y]=pointerCoord(e);lastX=x;lastY=y;activeMousePointer=e.pointerId;view.setPointerCapture(e.pointerId);
  if(e.button===2||state.tool==='look'||e.altKey){turning=true;return}
  const h=hitTest(x,y);if(!h){toast('Walk closer to the train to paint · spray reach 3.2 m');return}
  beginStroke(h);dragging=true;lastHit=null;dragStroke(h);
});
view.addEventListener('pointermove',e=>{
  const [x,y]=pointerCoord(e);
  if(e.pointerType==='touch'){
    if(!activeTouches.has(e.pointerId))return;
    activeTouches.set(e.pointerId,{x,y});
    if(activeTouches.size>=2){const gap=touchGap();if(pinchDistance>0&&gap>0){fov=clamp(pinchStartFov*pinchDistance/gap,Math.PI/5.5,Math.PI/2.5);displayZoom()}return}
    if(ignoreUntilTouchRelease)return;
    if(turning){cam.yaw+=(x-lastX)*.003;cam.pitch=clamp(cam.pitch-(y-lastY)*.003,-1.15,1.15)}
    else if(dragging)dragStroke(hitTest(x,y));
    lastX=x;lastY=y;return;
  }
  if(activeMousePointer!==null&&e.pointerId!==activeMousePointer)return;
  if(turning){cam.yaw+=(x-lastX)*.003;cam.pitch=clamp(cam.pitch-(y-lastY)*.003,-1.15,1.15)}
  else if(dragging)dragStroke(hitTest(x,y));
  lastX=x;lastY=y;let h=hitTest(x,y);view.style.cursor=turning?'grabbing':state.tool==='look'?'grab':h?'crosshair':'default';
});
function endPointer(e){
  if(e.pointerType==='touch'){
    activeTouches.delete(e.pointerId);
    if(activeTouches.size===0){ignoreUntilTouchRelease=false;pinchDistance=0;stopStroke()}
    else if(activeTouches.size===1){ignoreUntilTouchRelease=true;stopStroke()}
    return;
  }
  if(activeMousePointer!==null&&e.pointerId!==activeMousePointer)return;
  activeMousePointer=null;stopStroke();
}
view.addEventListener('pointerup',endPointer);view.addEventListener('pointercancel',endPointer);
view.addEventListener('lostpointercapture',e=>{if(e.pointerType==='touch'){activeTouches.delete(e.pointerId);if(activeTouches.size===0){ignoreUntilTouchRelease=false;pinchDistance=0;stopStroke()}}});
view.addEventListener('contextmenu',e=>e.preventDefault());
view.addEventListener('wheel',e=>{speed=clamp(speed+(e.deltaY>0?-.7:.7),2,15);toast('Move speed: '+speed.toFixed(1))},{passive:true});
function doUndo(){let u=undo.pop();if(!u){toast('No more strokes to undo');return}for(let i=activeDrips.length-1;i>=0;i--)if(activeDrips[i].actionId===u.id)activeDrips.splice(i,1);for(let i=wetPools.length-1;i>=0;i--)if(wetPools[i].actionId===u.id)wetPools.splice(i,1);u.p.ctx.putImageData(u.snap,0,0);dirty.add(u.p);$('undoCount').textContent=undo.length+' / 7';strokes=Math.max(0,strokes-1);$('paintedCount').textContent=strokes+' strokes';saveLater()}
$('undo').onclick=doUndo;$('clear').onclick=()=>{if(!confirm('Erase all paint from every train side? This cannot be undone.'))return;wetPools.length=0;activeDrips.length=0;panels.forEach(p=>{p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);dirty.add(p)});undo=[];strokes=0;$('paintedCount').textContent='0 strokes';$('undoCount').textContent='0 / 7';saveLater();toast('All paint cleared')};
$('resetCamera').onclick=()=>{cam={x:1.7,y:gb3SprayConfig.cameraHeight,z:16.5,yaw:0,pitch:-.025};toast('Camera reset')};
// True element fullscreen where supported. Some mobile browsers do not support
// requestFullscreen() for arbitrary divs, so use a portal-to-body fallback.
// Both modes keep the joystick/UI attached to the actual game viewport.
let immersivePlaceholder=null, immersive=false;
function viewportChanged(){
  resetJoystick();
  requestAnimationFrame(()=>{resize();updateVisibleGameArea()});
}
function enterImmersive(){
  if(immersive)return;
  immersivePlaceholder=document.createComment('GBattle 3D restore position');
  root.parentNode.insertBefore(immersivePlaceholder,root);
  document.body.appendChild(root);
  root.classList.add('gb3-immersive');
  document.documentElement.classList.add('gb3-immersive-open');
  immersive=true;viewportChanged();
}
function leaveImmersive(){
  if(!immersive)return;
  root.classList.remove('gb3-immersive');
  document.documentElement.classList.remove('gb3-immersive-open');
  if(immersivePlaceholder&&immersivePlaceholder.parentNode){
    immersivePlaceholder.parentNode.replaceChild(root,immersivePlaceholder);
  }
  immersivePlaceholder=null;immersive=false;viewportChanged();
}
$('fullscreen').onclick=async()=>{
  // Preserve the original desktop fullscreen path. Only phones use the
  // immersive portal fallback required for mobile browser compatibility.
  if(!isTouchDevice){
    try{
      if(document.fullscreenElement===root)await document.exitFullscreen();
      else await root.requestFullscreen?.();
    }catch(err){console.warn('Desktop fullscreen unavailable',err)}
    return;
  }
  if(document.fullscreenElement===root){await document.exitFullscreen();return}
  if(immersive){leaveImmersive();return}
  try{
    if(typeof root.requestFullscreen!=='function')throw Error('Element fullscreen unsupported');
    await root.requestFullscreen({navigationUI:'hide'});
  }catch(err){enterImmersive()}
};
document.addEventListener('fullscreenchange',()=>{
  if(isTouchDevice){
    root.classList.toggle('gb3-native-fullscreen',document.fullscreenElement===root);
    viewportChanged();
  }else{
    root.classList.remove('gb3-native-fullscreen');
    requestAnimationFrame(resize);
  }
});
// When the Shopify header/browser bars occupy part of the phone screen,
// anchor the controls to the visible part of the game, not a clipped bottom.
let visibleAreaQueued=false;
function updateVisibleGameArea(){
  if(!isTouchDevice)return;
  const rect=root.getBoundingClientRect();
  const vv=window.visualViewport;
  const top=vv?vv.offsetTop:0;
  const bottom=top+(vv?vv.height:window.innerHeight);
  const cutoff=Math.max(0,Math.ceil(rect.bottom-bottom));
  const visible=Math.max(0,Math.min(rect.bottom,bottom)-Math.max(rect.top,top));
  root.style.setProperty('--gb3-visible-bottom-offset',cutoff+'px');
  root.classList.toggle('gb3-short-visible',visible>0&&visible<390);
}
function scheduleVisibleGameArea(){
  if(visibleAreaQueued)return;
  visibleAreaQueued=true;
  requestAnimationFrame(()=>{visibleAreaQueued=false;updateVisibleGameArea()});
}
if(isTouchDevice){
  window.addEventListener('scroll',scheduleVisibleGameArea,{passive:true});
  window.addEventListener('resize',scheduleVisibleGameArea,{passive:true});
  window.addEventListener('orientationchange',()=>setTimeout(viewportChanged,160),{passive:true});
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',scheduleVisibleGameArea,{passive:true});
    window.visualViewport.addEventListener('scroll',scheduleVisibleGameArea,{passive:true});
  }
  const observer=new ResizeObserver(scheduleVisibleGameArea);
  observer.observe(root);
  updateVisibleGameArea();
}

$('photo').onclick=()=>{let a=document.createElement('a');a.href=view.toDataURL('image/png');a.download='gbattle-3d-yard-'+Date.now()+'.png';a.click();toast('Screenshot downloaded')};
const addEvents=(sel,fn)=>root.querySelectorAll(sel).forEach(n=>n.onclick=fn);
$('help').onclick=()=>{$('helpModal').hidden=false};$('settings').onclick=()=>{$('settingsModal').hidden=false};root.querySelectorAll('[data-close]').forEach(n=>n.onclick=()=>n.closest('.modal').hidden=true);
$('quality').onchange=e=>{quality=Number(e.target.value);resize();toast('Graphics quality updated')};$('fog').onchange=e=>fog=e.target.checked?1:0;
let toastTimer;function toast(msg){let n=$('toast');n.textContent=msg;n.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>n.classList.remove('show'),2600)}
// IndexedDB stores complete paint-layer images. No need to upload artwork or send private data.
let db=null;
// Pause paint input/autosave while saved layers are being restored to the new train.
let gb3PaintRestoring=false;
try{
  const req=indexedDB.open('gbattle3d-yard-v1',1);
  req.onupgradeneeded=()=>req.result.createObjectStore('paint');
  req.onsuccess=()=>{db=req.result;if(c30LoadStatus.state==='ready')gb3RestoreTrainPaint(gb3PaintSaveKey,gb3ModelEpoch);gb3SecondaryRestore()};
  req.onerror=()=>toast('Browser storage unavailable; local autosave may not work');
}catch(err){
  // Private browsing / storage restrictions must not disable the game controls.
  console.warn('GBattle 3D: local storage unavailable',err);
  toast('Local autosave unavailable on this browser');
}
function snapshot(){return {version:1,strokes,created:Date.now(),layers:Object.fromEntries(panels.map(p=>[p.name,p.canvas.toDataURL('image/png')]))}}
let saveTimer;function saveLater(){clearTimeout(saveTimer);if(gb3PaintRestoring)return;saveTimer=setTimeout(()=>{if(!db||gb3PaintRestoring)return;try{let tx=db.transaction('paint','readwrite');tx.objectStore('paint').put(snapshot(),c30LoadStatus.state==='ready'?gb3PaintSaveKey:'session');tx.oncomplete=()=>{$('saveState').textContent='SAVED ON DEVICE'};gb3SecondarySave();tx.onerror=()=>{$('saveState').textContent='SAVE FAILED'}}catch(e){$('saveState').textContent='SAVE FAILED'}},1300)}
function restoreState(record,notify=true,epoch=gb3ModelEpoch){
 if(epoch!==gb3ModelEpoch){return;}
 if(record?.version!==1||!record.layers||Object.keys(record.layers).length>65){gb3PaintRestoring=false;return;}
 wetPools.length=0;activeDrips.length=0;
 let pending=0;
 const finished=()=>{pending--;if(pending===0&&epoch===gb3ModelEpoch)gb3PaintRestoring=false;};
 for(const p of panels){
  const data=record.layers[p.name];
  if(!data||typeof data!=='string'||!data.startsWith('data:image/png;base64,'))continue;
  pending++;
  const im=new Image();
  im.onload=()=>{
   if(epoch===gb3ModelEpoch&&panels.includes(p)){
    p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);
    p.ctx.drawImage(im,0,0,p.canvas.width,p.canvas.height);
    dirty.add(p);if(notify)saveLater();
   }
   finished();
  };
  im.onerror=finished;
  im.src=data;
 }
 strokes=Number(record.strokes)||0;
 $('paintedCount').textContent=strokes+' strokes';
 $('saveState').textContent='LOADED LOCAL';
 if(!pending)gb3PaintRestoring=false;
 if(notify)toast('Painting loaded');
}
function gb3RestoreTrainPaint(key,epoch){
 if(epoch!==gb3ModelEpoch)return;
 clearTimeout(saveTimer);
 if(!db){gb3PaintRestoring=false;return;}
 gb3PaintRestoring=true;
 try{
  const tx=db.transaction('paint','readonly');
  const req=tx.objectStore('paint').get(key);
  req.onsuccess=()=>{
   if(epoch!==gb3ModelEpoch||key!==gb3PaintSaveKey)return;
   if(req.result)restoreState(req.result,false,epoch);
   else gb3PaintRestoring=false;
  };
  req.onerror=()=>{if(epoch===gb3ModelEpoch)gb3PaintRestoring=false;
   console.warn('GBattle: saved painting could not be read for the selected train');};
 }catch(err){gb3PaintRestoring=false;console.warn('GBattle: local paint restore unavailable',err)}
}
// Train chooser swaps GPU models inside the running game on desktop and mobile.
// URLs only record the selected train for bookmarks and refreshes.
// C30 remains default; C6 is the only alternative. C8 has been retired.
function gb3SetupTrainChooser(){
 const topActions=root.querySelector('.top-actions');
 if(!topActions||topActions.querySelector('[data-gb3-train-open]'))return;
 const open=document.createElement('button');open.type='button';open.className='gb3-train-open';
 open.setAttribute('data-gb3-train-open','');open.setAttribute('aria-haspopup','dialog');
 open.textContent='🚆';open.title='Choose train · '+gb3TrainName;open.setAttribute('aria-label','Choose train · '+gb3TrainName);
 const helpButton=$('help');topActions.insertBefore(open,helpButton);
 const dialog=document.createElement('div');dialog.className='modal gb3-train-modal';
 dialog.setAttribute('data-gb3-train-modal','');dialog.setAttribute('role','dialog');
 dialog.setAttribute('aria-modal','true');dialog.setAttribute('aria-labelledby','gb3-train-title');
 dialog.hidden=true;
 dialog.innerHTML=`<div class="modal-panel gb3-train-panel">
  <button type="button" class="close" data-gb3-train-close aria-label="Close train chooser">×</button>
  <span class="eyebrow">THE YARD · TRAIN SELECTION</span>
  <h2 id="gb3-train-title">CHOOSE TRAIN</h2>
  <p class="muted">Choose a train to paint. Your graffiti is saved separately for each train on this device.</p>
  <div class="gb3-train-options" role="group" aria-label="Available trains">
   <p class="gb3-train-country">SWEDEN · STOCKHOLM</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="stockholm-c30"><strong>Stockholm-C30</strong><small>Modern Stockholm subway</small><span class="gb3-train-indicator"></span></button>
   <button type="button" class="gb3-train-option" data-gb3-train-target="stockholm-c6"><strong>Stockholm-C6</strong><small>Classic green Stockholm subway</small><span class="gb3-train-indicator"></span></button>
   <p class="gb3-train-country">CHILE · SANTIAGO</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="santiago-ns74"><strong>Santiago NS-74</strong><small>Santiago Metro</small><span class="gb3-train-indicator"></span></button>
   <p class="gb3-train-country">FRANCE · PARIS</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="paris-mp73"><strong>Paris MP-73</strong><small>Paris Métro</small><span class="gb3-train-indicator"></span></button>
   <p class="gb3-train-country">UNITED KINGDOM · LONDON</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="london-2009stock"><strong>London-2009 Stock</strong><small>London Underground</small><span class="gb3-train-indicator"></span></button>
  </div>
  <p class="muted">Trains change inside the yard. Your camera and controls stay in place.</p>
  <div class="gb3-train-status" role="status" aria-live="polite"></div>
  <button class="wide" type="button" data-gb3-train-close>BACK TO YARD</button>
 </div>`;
 root.appendChild(dialog);
 const status=dialog.querySelector('.gb3-train-status');
 let busy=false;
 const close=()=>{if(busy)return;dialog.hidden=true;open.setAttribute('aria-expanded','false');open.focus({preventScroll:true})};
 const show=()=>{root.querySelectorAll('.modal').forEach(m=>m.hidden=true);
  dialog.hidden=false;open.setAttribute('aria-expanded','true');
  dialog.querySelector('[data-gb3-train-target]:not([disabled])')?.focus({preventScroll:true});};
 open.setAttribute('aria-expanded','false');open.addEventListener('click',()=>dialog.hidden?show():close());
 dialog.querySelectorAll('[data-gb3-train-close]').forEach(b=>b.addEventListener('click',close));
 dialog.addEventListener('click',e=>{if(e.target===dialog)close()});
 dialog.addEventListener('keydown',e=>{if(e.key==='Escape'){e.stopPropagation();close()}});
 dialog.querySelectorAll('[data-gb3-train-target]').forEach(b=>{
  const target=b.getAttribute('data-gb3-train-target');
  const isSelected=()=>target===gb3KeyToPublic[gb3TrainSelection];
  const refresh=()=>{const selected=isSelected();b.setAttribute('aria-current',String(selected));
   b.disabled=selected;b.querySelector('.gb3-train-indicator').textContent=selected?'✓ CURRENT TRAIN':'SELECT TRAIN →';};
  refresh();
  b.addEventListener('click',async()=>{
   if(busy||isSelected())return;
   if(gb3PaintRestoring){status.textContent='Finishing saved painting. Please try again in a moment.';return;}
   busy=true;status.textContent='Saving your painting…';
   stopStroke();gb3SecondarySave();clearTimeout(saveTimer);
   const previousKey=gb3PaintSaveKey;
   try{
    if(c30LoadStatus.state==='ready'){
     if(!db){
      if(strokes>0&&!confirm('Local saving is unavailable. Changing train may lose your painting. Continue?')){
       status.textContent='Train change cancelled';return;
      }
     }else{
      try{
       await new Promise((resolve,reject)=>{
        const tx=db.transaction('paint','readwrite');
        tx.objectStore('paint').put(snapshot(),previousKey);
        tx.oncomplete=resolve;
        tx.onerror=()=>reject(tx.error||Error('Save failed'));
        tx.onabort=()=>reject(tx.error||Error('Save cancelled'));
       });
      }catch(err){
       console.warn('GBattle: could not save paint before train change',err);
       if(!confirm('Painting could not be saved. Switch train anyway?')){
        status.textContent='Train change cancelled';return;
       }
      }
     }
    }
    const next=gb3TrainRegistry[target].key;
    status.textContent='Preparing '+gb3TrainRegistry[target].name+'… your yard remains open.';
    const ok=await gb3LoadTrain(next,true);
    if(ok){
     // URL reflects the active train without a navigation, page reload or history entry.
     try{const url=new URL(window.location.href);url.searchParams.set('gb3train',target);
      url.searchParams.delete('gb3c8model');window.history.replaceState(window.history.state,'',url.toString());}
     catch(err){console.warn('GBattle: could not update train link',err)}
     status.textContent='Ready to paint '+gb3TrainName;
     for(const other of dialog.querySelectorAll('[data-gb3-train-target]')){
      const current=other.getAttribute('data-gb3-train-target')===gb3KeyToPublic[gb3TrainSelection];
      other.setAttribute('aria-current',String(current));other.disabled=current;
      other.querySelector('.gb3-train-indicator').textContent=current?'✓ CURRENT TRAIN':'SELECT TRAIN →';
     }
     dialog.hidden=true;open.setAttribute('aria-expanded','false');
     open.title='Choose train · '+gb3TrainName;
     open.setAttribute('aria-label','Choose train · '+gb3TrainName);
     open.focus({preventScroll:true});
    }else status.textContent='Could not load train. Your previous train is still available.';
   }finally{busy=false;}
  });
 });
}
gb3SetupTrainChooser();
const gb3WorldChooserStyle=document.createElement('style');
gb3WorldChooserStyle.textContent=`.gb3-game .gb3-train-options{max-height:min(45vh,380px);overflow-y:auto;overscroll-behavior:contain;padding:2px 4px 8px 0;scrollbar-width:thin}.gb3-game .gb3-train-options .gb3-train-country{font-size:11px;font-weight:900;letter-spacing:.16em;color:#ffc90e;border-bottom:1px solid rgba(255,201,14,.28);margin:13px 0 7px;padding-bottom:5px}.gb3-game .gb3-train-option{margin-bottom:7px}`;
root.appendChild(gb3WorldChooserStyle);
// Compact icon-only upper controls; titles and aria-labels remain descriptive.
// No asset filename changes or dependency on external icon fonts.
for(const [name,glyph,label] of [['help','?','Help and controls'],['fullscreen','⛶','Toggle fullscreen'],['settings','⚙','Display settings']]){
 const b=$(name);if(!b)continue;b.textContent=glyph;b.setAttribute('aria-label',label);b.title=label;
 b.setAttribute('aria-pressed','false');
}
// Reflect actual modal/fullscreen state, including Escape and outside close.
function gb3RefreshTopActions(){
 const on={'help':!$('helpModal')?.hidden,'settings':!$('settingsModal')?.hidden,
   'fullscreen':document.fullscreenElement===root||!!immersive};
 for(const [key,v] of Object.entries(on)){const b=$(key);if(b)b.setAttribute('aria-pressed',String(!!v));}
}
root.addEventListener('click',()=>queueMicrotask(gb3RefreshTopActions));
document.addEventListener('fullscreenchange',gb3RefreshTopActions);
gb3RefreshTopActions();
// Two-stick mobile gameplay. Default is DUAL ON on new devices.
// TILT requests Android landscape fullscreen; it does not control the camera.
let gb3TiltOn=false,gb3RightTouchId=null,gb3TiltOwnsFullscreen=false,gb3TiltOwnsImmersive=false;
const gb3ReadDualSetting=()=>{try{const v=localStorage.getItem('gb3-dual-v250');return v===null?true:v!=='0';}catch(_){return true;}};
const gb3WriteDualSetting=v=>{try{localStorage.setItem('gb3-dual-v250',v?'1':'0');}catch(_){}};
if(isTouchDevice){
 const trainButton=root.querySelector('[data-gb3-train-open]');
 const makeToggle=(label,description)=>{
  const b=document.createElement('button');b.type='button';b.className='gb3-feature-toggle';b.textContent=label;
  b.title=description;b.setAttribute('aria-pressed','false');
  trainButton?.insertAdjacentElement('afterend',b);return b;
 };
 const tiltButton=makeToggle('↔','Landscape fullscreen (Android orientation)');
 const dualButton=makeToggle('🕹️','Toggle dual joystick: move and look');
 dualButton.setAttribute('aria-label','Toggle dual joystick');tiltButton.setAttribute('aria-label','Toggle landscape fullscreen');
 const rightPad=document.createElement('div');rightPad.className='gb3-rightpad';
 rightPad.setAttribute('role','group');rightPad.setAttribute('aria-label','Look joystick');
 rightPad.innerHTML='<div class="gb3-rightknob" aria-hidden="true">✥</div>';
 root.querySelector('.gb3-mobile-ui').appendChild(rightPad);
 const rightKnob=rightPad.querySelector('.gb3-rightknob');
 let gb3RightLook={x:0,y:0};
 function resetRight(){gb3RightTouchId=null;rightKnob.style.transform='translate(0,0)';rightPad.classList.remove('is-active');gb3RightLook={x:0,y:0}}
 function lookInput(e){
  const r=rightPad.getBoundingClientRect(),radius=Math.max(1,(r.width-rightKnob.offsetWidth)/2);
  let dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2);
  const distance=Math.hypot(dx,dy),scale=Math.max(1,distance/radius);dx/=scale;dy/=scale;
  rightKnob.style.transform=`translate(${dx}px,${dy}px)`;
  gb3RightLook={x:dx/radius,y:dy/radius};
 }
 rightPad.addEventListener('pointerdown',e=>{if(!gb3DualOn||gb3RightTouchId!==null)return;e.preventDefault();gb3RightTouchId=e.pointerId;rightPad.setPointerCapture(e.pointerId);rightPad.classList.add('is-active');lookInput(e)});
 rightPad.addEventListener('pointermove',e=>{if(e.pointerId!==gb3RightTouchId)return;e.preventDefault();lookInput(e)});
 for(const ev of ['pointerup','pointercancel','lostpointercapture'])rightPad.addEventListener(ev,e=>{if(e.pointerId===gb3RightTouchId)resetRight()});
 function setDual(v){
  gb3DualOn=!!v;dualButton.textContent='🕹️';dualButton.title=gb3DualOn?'Dual joystick ON':'Dual joystick OFF';
  dualButton.setAttribute('aria-pressed',String(gb3DualOn));root.classList.toggle('gb3-dual-on',gb3DualOn);
  resetRight();gb3WriteDualSetting(gb3DualOn);
  if(gb3DualOn){if(state.tool==='look')selectTool('spray');mobileTouchMode='paint';}
  else{mobileTouchMode='look';stopStroke();}
  renderTouchModes();
  $('hint').textContent=gb3DualOn?'DUAL: MOVE + LOOK JOYSTICKS · TOUCH TRAIN TO PAINT':'SELECT LOOK OR PAINT TO USE TOUCH';
 }
 dualButton.addEventListener('click',()=>setDual(!gb3DualOn));setDual(gb3ReadDualSetting());
 async function setTilt(v){
  if(!v){
   gb3TiltOn=false;tiltButton.textContent='↔';tiltButton.title='Landscape fullscreen OFF';tiltButton.setAttribute('aria-pressed','false');
   root.classList.remove('gb3-tilt-on');
   try{screen.orientation?.unlock?.()}catch(_){}
   if(gb3TiltOwnsFullscreen&&document.fullscreenElement===root){try{await document.exitFullscreen()}catch(_){}}
   if(gb3TiltOwnsImmersive&&immersive)leaveImmersive();
   gb3TiltOwnsFullscreen=false;gb3TiltOwnsImmersive=false;
   viewportChanged();return;
  }
  try{
   if(document.fullscreenElement!==root&&!immersive){
    if(typeof root.requestFullscreen==='function'){
     try{await root.requestFullscreen({navigationUI:'hide'});gb3TiltOwnsFullscreen=true;}
     catch(_){enterImmersive();gb3TiltOwnsImmersive=true;}
    }else{enterImmersive();gb3TiltOwnsImmersive=true;}
   }
   let locked=false;
   try{if(screen.orientation?.lock){await screen.orientation.lock('landscape');locked=true;}}catch(err){console.info('Landscape orientation lock unavailable:',err)}
   gb3TiltOn=true;root.classList.add('gb3-tilt-on');
   tiltButton.textContent='↔';tiltButton.title='Landscape fullscreen ON';tiltButton.setAttribute('aria-pressed','true');
   if(!locked)toast('Fullscreen enabled · rotate phone sideways / enable Auto-rotate');
   else toast('Landscape fullscreen enabled');
   viewportChanged();
  }catch(err){console.warn('Landscape fullscreen unavailable',err);toast('Fullscreen unavailable on this browser')}
 }
 tiltButton.addEventListener('click',()=>{void setTilt(!gb3TiltOn)});
 document.addEventListener('fullscreenchange',()=>{
  if(gb3TiltOn&&gb3TiltOwnsFullscreen&&document.fullscreenElement!==root){
   gb3TiltOn=false;gb3TiltOwnsFullscreen=false;tiltButton.textContent='↔';tiltButton.title='Landscape fullscreen OFF';
   tiltButton.setAttribute('aria-pressed','false');root.classList.remove('gb3-tilt-on');
   try{screen.orientation?.unlock?.()}catch(_){}
  }
 });
 root.gb3StepOptionalLook=dt=>{
  if(gb3DualOn){cam.yaw+=gb3RightLook.x*dt*1.9;cam.pitch=clamp(cam.pitch-gb3RightLook.y*dt*1.3,-1.15,1.15);}
 };
}
$('online').textContent='THE YARD';$('online').style.color='#e4c56e';
// Highly visible joystick; relative thumb position gives normalized movement.
let touchVec={x:0,y:0},touchId=null;const pad=$('touchpad'),knob=$('touchKnob');
function resetJoystick(){touchId=null;touchVec={x:0,y:0};knob.style.transform='translate(0,0)';pad.classList.remove('is-active')}
pad.addEventListener('pointerdown',e=>{if(touchId!==null)return;e.preventDefault();touchId=e.pointerId;pad.setPointerCapture(touchId);pad.classList.add('is-active');touchUpdate(e)});
pad.addEventListener('pointermove',e=>{if(e.pointerId===touchId){e.preventDefault();touchUpdate(e)}});
pad.addEventListener('pointerup',e=>{if(e.pointerId===touchId)resetJoystick()});
pad.addEventListener('pointercancel',e=>{if(e.pointerId===touchId)resetJoystick()});
pad.addEventListener('lostpointercapture',e=>{if(e.pointerId===touchId)resetJoystick()});
function touchUpdate(e){let r=pad.getBoundingClientRect(),radius=(r.width-knob.offsetWidth)/2,dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2),scale=Math.max(1,Math.hypot(dx,dy)/radius);dx/=scale;dy/=scale;touchVec={x:dx/radius,y:-dy/radius};knob.style.transform=`translate(${dx}px,${dy}px)`}
function firstVisit(key){
  try{
    if(sessionStorage.getItem(key))return false;
    sessionStorage.setItem(key,'yes');return true;
  }catch(err){return true}
}
if(isTouchDevice){
  if(firstVisit('gbattle3d-mobile-controls-v3'))$('helpModal').hidden=false;
}else if(firstVisit('gbattle3d-help-seen'))$('helpModal').hidden=false;
}
// Native Shopify section lifecycle: support initial load and theme-editor reload.
function gb3Boot(){document.querySelectorAll('[data-gb3-root]').forEach(gbattle3DInit);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',gb3Boot,{once:true});
else gb3Boot();
document.addEventListener('shopify:section:load',gb3Boot);
